/*!
 * Emma und die Eicheln – Spiel als Shopify-Abschnitt (Online Store 2.0)
 * Wunderwunsch GmbH · Umbau der Einzelseite index.html auf einen Theme-Abschnitt (Stand 01.11.2026)
 *
 * Gehört zu: sections/emma-und-die-eicheln.liquid und assets/emma-und-die-eicheln.css
 * Startet in jedem Element [data-emma-root] ein eigenes Spiel (mehrere Spiele pro Seite möglich).
 * Einstellung aus dem Abschnitt (data-Attribut am Wurzelelement):
 *   data-api-url   Adresse der Schnittstelle (api.php oder eigene Umsetzung, siehe LIESMICH „SCHNITTSTELLE“).
 *                  Leer = Spiel ohne Anmeldung und Bestenliste.
 *
 * LEVEL-ZEICHEN (unten bei "const LEVELS" kannst du die Level umbauen, ein Zeichen = ein Feld):
 *   # = Boden/Fels   - = Plattform (von unten durchspringbar)   . = leere Luft   o = Eichel   h = Herz (+1 Leben)
 *   k = Kastanie (rollt)   w = Wespe (fliegt)   S = Start   p = Pilz (Kontrollpunkt)   F = Hasenbau (Ziel)
 *   L = Löwe (Booster, macht schnell)   B = Bär (gibt Tipps, die Texte stehen bei "tips" im Level)
 *   Wer die Level ändert, muss auf dem Server in config.php die Prüfwerte anpassen (LIESMICH_Shopify.txt).
 *
 * Aufbau dieser Datei:
 *   1. createGame(root): eine Spiel-Instanz. Darin steht der ORIGINAL-Spielcode (Level, Physik, Figuren,
 *      Zeichnen) aus index.html Z. 169–1099 zeilengleich und bewusst NICHT eingerückt, damit man ihn direkt
 *      mit dem Original vergleichen kann. Dort sind nur 4 Zeilen geändert ($ / document.body, siehe Kasten).
 *   2. Danach in createGame: Bildschirme, Online-Teil, Steuerung, Vollbild-Ebene, Größe, Hauptschleife.
 *   3. Verwaltung: Starten und Abbauen je Abschnitt, Theme-Editor (shopify:section:load/unload).
 * Einziger globaler Name: window.EmmaUndDieEicheln (scan, unmount, instances) – verhindert doppelten Start,
 * falls die Datei zweimal geladen wird, und hilft beim Prüfen in der Browser-Konsole.
 */
(function () {
'use strict';

const NS = 'EmmaUndDieEicheln';
if (window[NS] && typeof window[NS].scan === 'function') { window[NS].scan(document); return; }

const instances = new Map();   // Wurzelelement -> Spiel-Instanz
const loginOnce = new Map();   // Anmelde-Link aus der E-Mail nur einmal einlösen (auch bei mehreren Spielen auf einer Seite)

// Server-Adresse aus der Einstellung: volle Adresse der Schnittstelle – api.php oder eine eigene Umsetzung
// (z. B. Shopify-App-Proxy /apps/emma). Nur eine Adresse mit "/" am Ende gilt als Ordner und bekommt "api.php" angehängt.
function normApi(u) {
  u = String(u || '').trim();
  if (!u) return '';
  return /\/$/.test(u) ? u + 'api.php' : u;
}

function createGame(root) {
const stage = root.querySelector('.emma-game');   // die Spielbühne (wandert für die Vollbild-Ebene ans Ende von <body>)
const slot = root.querySelector('.emma-slot');     // ihr Platz im Seitenfluss (16:9)
if (!stage || !slot) throw new Error('Markup unvollständig: .emma-slot oder .emma-game fehlt');
const testMode = root.hasAttribute('data-emma-test');   // nur Testseite, der Abschnitt setzt das nie
const offs = [];
function on(target, type, fn, opts) { target.addEventListener(type, fn, opts); offs.push(() => target.removeEventListener(type, fn, opts)); }
let destroyed = false, layerOpen = false, nativeFs = false, visible = true;
const loginToken = (() => { try { return new URLSearchParams(location.search).get('login') || ''; } catch (e) { return ''; } })();

/* ##########################################################################################
   ORIGINAL-SPIELCODE aus index.html Z. 169–1099 – zeilengleich übernommen, nicht eingerückt.
   Geändert sind nur diese 4 Zeilen (alles andere Zeichen für Zeichen wie im Original):
     Z.  281  $ sucht in der Spielbühne statt im ganzen Dokument
     Z.  650  Zeichenfläche über die Klasse .emma-canvas statt der ID #c
     Z. 1082  Touch-Merkmal steht an der Bühne (emma-is-touch) statt an <body> (touch)
     Z. 1099  Overlay über die Klasse .emma-overlay statt der ID #overlay
   ########################################################################################## */
/* =====================================================================
   LEVEL – hier kannst du bauen! Jede Zeile ist eine Reihe von Feldern.
   Zeichen siehe ganz oben in der Datei. Die Bär-Texte stehen bei jedem Level unter "tips" (von links nach rechts).
   Speichern, Seite neu laden, fertig.
   ===================================================================== */
const LEVELS = [
  {
    name: 'Wald', theme: 'wald',
    map: [
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      ".............................................................h......................................",
      "............................................................---.....................................",
      "..............................................w..........................................w..........",
      "......................................................oooo..........................................",
      "........oooo............................ooo...........----..........................ooo.............",
      "........----......oo.........oo.......................................oo............................",
      ".............................##.....................................................................",
      "..S..ooB.......B......B.k...####....k.........B...p..L......k...ooo........oo.k.........B.oo...F....",
      "##################..####################...###########################..############...#############",
      "##################..####################...###########################..############...#############"
    ],
    tips: [
      [
            "Hallo, ich bin Bruno! Lauf mit den Pfeiltasten oder A und D. Springen geht mit der Leertaste.",
            "Hallo, ich bin Bruno! Lauf mit den Knöpfen links unten. Springen geht mit dem großen Knopf rechts."
      ],
      "Eine Lücke! Halte den Sprung gedrückt für einen großen Sprung. Kurz tippen ist nur ein kleiner Hüpfer.",
      "Spring Kastanien auf den Kopf, dann sind sie platt. Von der Seite tut es weh!",
      "Der rote Pilz merkt sich, wo du warst. Dahinter wartet Leo der Löwe: Berühr ihn, dann flitzt du ganz schnell!",
      "Da vorne ist dein Hasenbau mit der Fahne. Lauf hinein, dann ist das Level geschafft!"
    ]
  },
  {
    name: 'Höhle', theme: 'hoehle',
    map: [
      "####################################################################################################",
      "####################################################################################################",
      "........##............#.................##................#..................#..........#...........",
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      "..........................oooo......................................................................",
      "..........................----...........................h..........................................",
      "........................................................---.........................................",
      "....................oooo.........ooo..............................ooo...........ooo.................",
      "..............ooo...----.....w..............oo......oo........w..............................w......",
      "............................................##......................................................",
      "..S.ooo.k..B.............k.....B......L.k...##...p..........k.........ooo.k.........B.ooo.k.....F...",
      "##############...################...################..############...###########...#################",
      "##############...################...################..############...###########...#################"
    ],
    tips: [
      "Hier sind Wespen unterwegs. Du kannst sie nicht besiegen. Weich ihnen einfach aus: unten durch oder oben drüber.",
      "Mit Leo bist du schnell, aber du springst auch weiter. Lass den Sprung früher los, dann landest du sicher.",
      "Fast geschafft! Noch eine Kastanie und eine Wespe, dann bist du zu Hause."
    ]
  },
  {
    name: 'Baumkronen', theme: 'krone',
    map: [
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      "....................................................................................................",
      ".............................................ooo....................................................",
      "............................w................---........................h......ooo.w................",
      "...........ooo.........oooo.............ooo.................w.oooo.....---.....---..................",
      "................ookL...----.............---........oo.p.kL....----..................................",
      "..Soook..B....#######...........ook.B.............#########...........B....k..........B.oook....F...",
      "###########...#######.........########............#########..........########........###############",
      "###########...#######.........########............#########..........########........###############",
      "###########...#######.........########............#########..........########........###############"
    ],
    tips: [
      "Baumkronen! Unter den Lücken ist kein Boden. Wenn du fällst, geht es am letzten Pilz weiter.",
      "Auf den Inseln hilft dir Leo richtig gut. Aber Vorsicht an den Kanten!",
      "Siehst du das Herz da oben? Es schenkt dir ein Extra-Leben.",
      "Gleich hast du es geschafft! Dahinten wartet dein Hasenbau."
    ]
  }
];

/* ======================= Spielgefühl (Physik) =======================
   Einheiten: Pixel (ein Feld = 16 Pixel) und Sekunden.                */
const T = 16, VIEW_H = 240;
const PHYS = {
  run: 115,        // Laufgeschwindigkeit
  accGround: 1100, // Beschleunigung am Boden
  accAir: 750,     // Beschleunigung in der Luft
  fricGround: 1400,
  fricAir: 350,
  jumpV: 390,      // Absprung-Tempo (großer Sprung ~3,8 Felder hoch)
  gravUp: 1250,    // Schwerkraft beim Steigen, solange Sprung gehalten wird
  gravDown: 1900,  // Schwerkraft beim Fallen / nach dem Loslassen
  cutV: 140,       // Loslassen bremst den Aufstieg auf dieses Tempo
  minJump: 0.07,   // so lange steigt Emma mindestens (kleiner Sprung)
  maxFall: 420,
  coyote: 0.10,    // kurz nach der Kante darf man noch springen
  buffer: 0.12,    // zu früh gedrückt? Sprung wird gemerkt
  stomp: 260,      // Abprall nach Draufspringen
  boostMul: 1.45,  // Löwen-Booster: so viel schneller läuft Emma
  boostTime: 7     // so viele Sekunden hält der Booster
};

/* ============================ Helfer ============================ */
const $ = s => stage.querySelector(s);
const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
function mkCanvas(w, h) { const c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
function rng(seed) {
  let s = (seed >>> 0) || 1;
  return () => { s ^= s << 13; s >>>= 0; s ^= s >>> 17; s ^= s << 5; s >>>= 0; return s / 4294967296; };
}
function overlap(a, b, shrink = 0) {
  return a.x + shrink < b.x + b.w - shrink && a.x + a.w - shrink > b.x + shrink &&
         a.y + shrink < b.y + b.h - shrink && a.y + a.h - shrink > b.y + shrink;
}

/* ========================= Pixel-Sprites ========================= */
function makeSprite(rows, pal, outline = '#2a140a') {
  const h = rows.length, w = Math.max(...rows.map(r => r.length));
  const c = mkCanvas(w + 2, h + 2), g = c.getContext('2d');
  const on = (x, y) => y >= 0 && y < h && x >= 0 && x < w && rows[y][x] && rows[y][x] !== '.' && pal[rows[y][x]];
  if (outline) {
    g.fillStyle = outline;
    for (let y = -1; y <= h; y++) for (let x = -1; x <= w; x++)
      if (!on(x, y) && (on(x - 1, y) || on(x + 1, y) || on(x, y - 1) || on(x, y + 1))) g.fillRect(x + 1, y + 1, 1, 1);
  }
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    const ch = rows[y][x];
    if (on(x, y)) { g.fillStyle = pal[ch]; g.fillRect(x + 1, y + 1, 1, 1); }
  }
  return c;
}
function flipH(src) {
  const c = mkCanvas(src.width, src.height), g = c.getContext('2d');
  g.translate(src.width, 0); g.scale(-1, 1); g.drawImage(src, 0, 0); return c;
}
const pair = (rows, pal) => { const s = makeSprite(rows, pal); return [s, flipH(s)]; };

/* ===== Die Figuren: Hase Emma, Bär Bruno, Löwe Leo. Gezeichnet mit Ellipsen und Strichen, keine Bilddatei nötig ===== */
function mk(w, h) { const c = mkCanvas(w, h); return [c, c.getContext('2d')]; }
function px(g, x, y, col, w = 1, h = 1) { g.fillStyle = col; g.fillRect(x, y, w, h); }
function ell(g, cx, cy, rx, ry, col) {
  g.fillStyle = col;
  for (let y = Math.floor(cy - ry); y <= Math.ceil(cy + ry); y++)
    for (let x = Math.floor(cx - rx); x <= Math.ceil(cx + rx); x++) {
      const dx = (x + 0.5 - cx) / rx, dy = (y + 0.5 - cy) / ry;
      if (dx * dx + dy * dy <= 1) g.fillRect(x, y, 1, 1);
    }
}
function limb(g, x0, y0, x1, y1, r, col) {
  const n = Math.max(2, Math.ceil(Math.hypot(x1 - x0, y1 - y0) * 1.5));
  for (let i = 0; i <= n; i++) { const k = i / n; ell(g, x0 + (x1 - x0) * k, y0 + (y1 - y0) * k, r, r, col); }
}
function outlined(src, col = '#2d1b16') {
  const w = src.width, h = src.height, out = mkCanvas(w + 2, h + 2), og = out.getContext('2d');
  const d = src.getContext('2d').getImageData(0, 0, w, h).data;
  const on = (x, y) => x >= 0 && y >= 0 && x < w && y < h && d[(y * w + x) * 4 + 3] > 0;
  og.fillStyle = col;
  for (let y = -1; y <= h; y++) for (let x = -1; x <= w; x++)
    if (!on(x, y) && (on(x - 1, y) || on(x + 1, y) || on(x, y - 1) || on(x, y + 1))) og.fillRect(x + 1, y + 1, 1, 1);
  og.drawImage(src, 1, 1);
  return out;
}
const pairC = c => { const o = outlined(c); return [o, flipH(o)]; };

// Hase Emma (schaut nach rechts): graubeige, rosa Ohren, ein Ohr knickt ab, Herz-Nase
// bf/ff = Fuß hinten/vorn, ex/ey = Ohren-Versatz
const HARE_POSES = {
  idle: { bf: [5.5, 26.5], ff: [11, 26.5], ex: 0,  ey: 0 },
  run1: { bf: [3, 26.5],   ff: [14.5, 25], ex: -1, ey: 1 },
  run2: { bf: [7, 26.5],   ff: [11, 26.5], ex: -1, ey: 0 },
  run3: { bf: [9.5, 24.5], ff: [15, 26.5], ex: -1, ey: 1 },
  jump: { bf: [1.5, 24],   ff: [16.5, 24.5], ex: -2, ey: 1 },
  fall: { bf: [6, 25.5],   ff: [12.5, 25.5], ex: 1, ey: -1 },
};
function drawHare(o) {
  const [c, g] = mk(23, 29);
  const F = '#cfc1b2', Fd = '#a99b8c', P = '#f3a2b2', Pd = '#e47f96', K = '#2d2a33', T = '#f7f1e9', Bp = '#948a81';
  const ex = o.ex, ey = o.ey;
  ell(g, 3.3, 22, 1.9, 1.9, T);                                     // Schwänzchen
  limb(g, 6.5, 23.5, o.bf[0], o.bf[1] - 0.5, 1.9, Fd); ell(g, o.bf[0] + 1, o.bf[1], 2.8, 1.35, Fd);   // hinteres Bein
  ell(g, 10 + ex, 9 + ey, 2.2, 4.6, Fd); ell(g, 10 + ex, 9.6 + ey, 1.1, 3, Pd);   // Schlappohr
  ell(g, 7.6 + ex, 5.2 + ey, 3.2, 1.9, Fd);
  ell(g, 8.5, 21.5, 5.2, 4.4, F); ell(g, 10, 22.4, 2.7, 3, Bp);       // Körper mit dunklem Bauchfleck
  limb(g, 11, 24, o.ff[0], o.ff[1] - 0.5, 1.9, F); ell(g, o.ff[0] + 1, o.ff[1], 2.8, 1.35, F);       // vorderes Bein
  ell(g, 14 + ex, 7 + ey, 2.4, 6.2, F); ell(g, 14.2 + ex, 7.6 + ey, 1.2, 4.5, P);  // aufrechtes Ohr
  ell(g, 13.5, 15.5, 6.5, 5.6, F);                                    // Kopf
  px(g, 16, 14, K, 1, 2);                                             // Auge
  ell(g, 15, 18, 1.7, 1.2, P);                                        // Bäckchen
  px(g, 19, 16, K, 2, 1); px(g, 19, 17, K, 1, 1);                     // Nase
  px(g, 17, 19, K, 2, 1);                                             // Lächeln
  px(g, 10, 11, Fd, 1, 1);
  return c;
}

// Bär Bruno (schaut den Spieler an): braun, helle Schnauze und Bauch, Herz-Nase
function drawBear(fr) {
  const [c, g] = mk(30, 29);
  const B = '#a9784f', Bd = '#8a5c3a', Cr = '#f2dcbc', Pk = '#f2a1ab', K = '#2d2a33';
  ell(g, 6, 5, 3.6, 3.6, B); ell(g, 6.2, 5.2, 1.7, 1.7, Cr);
  ell(g, 24, 5, 3.6, 3.6, B); ell(g, 23.8, 5.2, 1.7, 1.7, Cr);
  ell(g, 15, 22, 9, 6.5, B); ell(g, 15, 23, 5.4, 5, Cr);
  for (let i = 0; i < 5; i++) px(g, 12 + i * 1.4 | 0, 21 + (i % 2) * 3, '#c9a37c', 1, 2);
  ell(g, 6.2, 26, 3.6, 2.5, B); ell(g, 6.5, 26.3, 1.6, 1.3, Cr);
  ell(g, 23.8, 26, 3.6, 2.5, B); ell(g, 23.5, 26.3, 1.6, 1.3, Cr);
  ell(g, 9.5, 20.5, 2.5, 4, Bd);
  if (fr === 0) ell(g, 20.5, 20.5, 2.5, 4, Bd);
  ell(g, 15, 12, 10.5, 8.6, B);
  ell(g, 15, 15.2, 4.3, 3.4, Cr);
  px(g, 13, 13, K, 2, 1); px(g, 16, 13, K, 2, 1); px(g, 13, 14, K, 5, 1); px(g, 14, 15, K, 3, 1); px(g, 15, 16, K, 1, 1);   // Herz-Nase
  px(g, 14, 18, K, 3, 1);
  px(g, 9, 10, K, 1, 2); px(g, 20, 10, K, 1, 2);
  ell(g, 9, 14.5, 1.8, 1.4, Pk); ell(g, 21, 14.5, 1.8, 1.4, Pk);
  if (fr !== 0) { limb(g, 25, 17, fr === 1 ? 26.5 : 27.5, fr === 1 ? 10 : 12, 2.2, Bd); }   // winkt
  return c;
}

// Löwe (schaut nach rechts): hellbraun mit dunkler, zackiger Mähne und Quasten-Schwanz
function drawLion(fr) {
  const [c, g] = mk(32, 24);
  const L = '#e3a76b', Ld = '#b57a45', M = '#7b4532', K = '#2d2a33';
  const s = fr ? 1 : 0;
  limb(g, 4.5, 13.5, 2.2, 9.5, 0.9, L); ell(g, 2.2, 8, 2, 2.4, M);          // Schwanz
  const leg = (x, col) => { px(g, Math.round(x) - 1, 15, 3, 6, col); ell(g, x + 0.3, 21.3, 2.5, 1.4, col); };
  leg(10.5 - s, Ld); leg(21 + s, Ld);                                         // hintere Beinreihe (dunkler)
  ell(g, 11.5, 14, 8, 4.6, L); ell(g, 11.5, 17.2, 6.5, 1.1, Ld);              // Körper
  leg(6.5 + s, L); leg(17.5 - s, L);
  ell(g, 21.5, 11.5, 7.2, 7.8, M);                                            // Mähne
  for (let i = 0; i < 12; i++) {
    const a = i / 12 * Math.PI * 2 + 0.2, r1 = 9 + (i % 2) * 1.6;
    limb(g, 21.5 + Math.cos(a) * 7, 11.5 + Math.sin(a) * 7.3, 21.5 + Math.cos(a) * r1, 11.5 + Math.sin(a) * r1 * 1.05, 1.1, M);
  }
  ell(g, 19, 7.8, 1.9, 1.9, L); ell(g, 19, 8, 0.9, 0.9, M);
  ell(g, 26.4, 7.6, 1.9, 1.9, L); ell(g, 26.4, 7.8, 0.9, 0.9, M);
  ell(g, 22.5, 12.5, 5.4, 5, L);                                              // Gesicht
  ell(g, 22.8, 9.4, 1.3, 2.6, Ld);
  px(g, 21, 12, K, 1, 2); px(g, 25, 12, K, 1, 2);
  px(g, 22, 14, K, 3, 1); px(g, 23, 15, K, 1, 1);
  px(g, 22, 16, K, 3, 1);
  return c;
}
function drawLionHead() {
  const [c, g] = mk(14, 14);
  ell(g, 7, 7, 6.5, 6.5, '#7b4532'); ell(g, 7, 8, 4.2, 3.9, '#e3a76b');
  px(g, 5, 7, '#2d2a33', 1, 2); px(g, 9, 7, '#2d2a33', 1, 2); px(g, 6, 10, '#2d2a33', 3, 1);
  return outlined(c);
}

const SPR = {};
function buildSprites() {
  SPR.hare = {};
  for (const k in HARE_POSES) SPR.hare[k] = pairC(drawHare(HARE_POSES[k]));
  SPR.bear = [0, 1, 2].map(f => outlined(drawBear(f)));
  SPR.lion = [0, 1].map(f => pairC(drawLion(f)));
  SPR.lionHead = drawLionHead();
  SPR.acorn = makeSprite([
    "....k...", ".cccccc.", "cCcCcCcc", ".aaaaaa.", ".aAaaaa.", ".aAaaaa.", "..aaaa..", "...aa..."
  ], { k: '#4a2a12', c: '#7a4a22', C: '#a06a34', a: '#e0a040', A: '#f8d88a' });
  SPR.heart = makeSprite([
    ".RR.RR.", "RrRRRRR", "RRRRRRR", ".RRRRR.", "..RRR..", "...R..."
  ], { R: '#e8304a', r: '#ffb3bf' });
  // Kastanie: 4 Roll-Bilder
  SPR.chest = [];
  for (let f = 0; f < 4; f++) {
    const a = f * Math.PI / 2 + 0.6, sx = 5.5 + Math.cos(a) * 3.1, sy = 5.5 + Math.sin(a) * 3.1;
    const rows = [];
    for (let y = 0; y < 12; y++) {
      const row = [];
      for (let x = 0; x < 12; x++) {
        const d = Math.hypot(x - 5.5, y - 5.5);
        let ch = '.';
        if (d <= 5.7) {
          ch = d > 4.7 ? 'b' : 'B';
          if (Math.hypot(x - sx, y - sy) < 2.1) ch = 'P';
          if (Math.hypot(x - 3.6, y - 3.2) < 1.2) ch = 'H';
        }
        row.push(ch);
      }
      rows.push(row);
    }
    rows[5][6] = 'E'; rows[5][7] = 'K'; rows[5][9] = 'E'; rows[5][10] = 'K';
    rows[4][6] = 'K'; rows[3][10] = 'K'; rows[4][9] = 'K';
    SPR.chest.push(pair(rows.map(r => r.join('')),
      { B: '#8a4a1e', b: '#5e3010', P: '#e9d3a2', H: '#c97c3c', E: '#ffffff', K: '#1a0d06' }));
  }
  SPR.chestFlat = makeSprite([
    "..bbbbbbbb..", ".bBBBBBBBBb.", "bBBKBBBBKBBb", "bbbbbbbbbbbb"
  ], { B: '#8a4a1e', b: '#5e3010', K: '#1a0d06' });
  // Wespe (schaut nach links)
  const WASP_PAL = { W: '#dff4ff', Y: '#f4c430', K: '#2a1a12', E: '#ffffff', S: '#2a1a12' };
  SPR.wasp = [
    pair(["....WW.WW...", "....WWWWW...", ".YYYKYYKYYK.", "KYEYKYYKYYKS", ".YYYKYYKYYK.", "..K..K..K..."], WASP_PAL),
    pair(["............", "...WWW.WWW..", ".YYYKYYKYYK.", "KYEYKYYKYYKS", ".YYYKYYKYYK.", "..K..K..K..."], WASP_PAL),
  ];
  // Pilz (Kontrollpunkt): aus = braun, an = rot
  const SHROOM = [
    "....RRRRRR....", "..RRWWRRRRRR..", ".RRRWWRRRWWRR.", "RRRRRRRRRWWRRR", "RRWWRRRRRRRRRR",
    ".rrrrrrrrrrrr.", "....tttttt....", "....tttttt....", "....tKttKt....", "....tttttt....", "...tttttttt..."
  ];
  SPR.shroomOff = makeSprite(SHROOM, { R: '#9a7a5a', W: '#d8c8b0', r: '#6e5640', t: '#e8dcc6', K: '#2a1a12' });
  SPR.shroomOn = makeSprite(SHROOM, { R: '#e0333a', W: '#ffffff', r: '#9a1e26', t: '#fff1dc', K: '#2a1a12' });
}

/* ===================== Kacheln & Hintergründe ===================== */
const THEMES = {
  wald:   { dirt: '#8a5a32', dirtD: '#6b4226', dirtL: '#a8774a', top: '#5cb33a', topL: '#8fdc5a', topD: '#3d8a2a', band: 4 },
  hoehle: { dirt: '#4f4666', dirtD: '#3b3352', dirtL: '#6c6390', top: '#7d73a8', topL: '#a9a0d4', topD: '#5a5180', band: 2 },
  krone:  { dirt: '#2f7a33', dirtD: '#225c27', dirtL: '#4b9a3e', top: '#4fae45', topL: '#86d65e', topD: '#2f7a33', band: 4 },
};
const tileCache = {}, bgCache = {};

function buildTiles(name) {
  if (tileCache[name]) return tileCache[name];
  const th = THEMES[name], R = rng(name.length * 977 + 13);
  const base = (seed) => {
    const c = mkCanvas(T, T), g = c.getContext('2d'), r = rng(seed);
    g.fillStyle = th.dirt; g.fillRect(0, 0, T, T);
    for (let i = 0; i < 6; i++) { g.fillStyle = th.dirtD; g.fillRect((r() * 15) | 0, (r() * 15) | 0, 2, 2); }
    for (let i = 0; i < 4; i++) { g.fillStyle = th.dirtL; g.fillRect((r() * 16) | 0, (r() * 16) | 0, name === 'krone' ? 3 : 1, name === 'krone' ? 2 : 1); }
    if (name === 'krone' && seed % 2) { g.fillStyle = '#6e4426'; g.fillRect(2, 9, 9, 1); g.fillRect(9, 8, 4, 1); }
    return c;
  };
  const mid = base(11), mid2 = base(12);
  const top = base(13), tg = top.getContext('2d');
  tg.fillStyle = th.top; tg.fillRect(0, 0, T, th.band);
  for (let x = 0; x < T; x += 2) { const e = (R() * 3) | 0; tg.fillRect(x, th.band, 2, e); if (e) { tg.fillStyle = th.topD; tg.fillRect(x, th.band + e, 2, 1); tg.fillStyle = th.top; } }
  tg.fillStyle = th.topL; tg.fillRect(0, 0, T, 1);
  if (name === 'wald') { tg.fillStyle = '#ffe36b'; tg.fillRect(5, 1, 1, 1); }
  if (name === 'krone') { tg.fillStyle = th.topL; for (let x = 1; x < T; x += 5) tg.fillRect(x, 1, 2, 1); }
  const bottom = base(14), bg2 = bottom.getContext('2d');
  bg2.fillStyle = th.dirtD; bg2.fillRect(0, T - 2, T, 2);
  if (name === 'hoehle') { bg2.fillRect(4, T - 4, 2, 2); bg2.fillRect(11, T - 3, 2, 1); }
  // Plattform
  const plat = mkCanvas(T, T), pg = plat.getContext('2d');
  if (name === 'wald') {
    pg.fillStyle = '#a0662e'; pg.fillRect(0, 1, T, 6);
    pg.fillStyle = '#c88a48'; pg.fillRect(0, 1, T, 1);
    pg.fillStyle = '#6a3e1a'; pg.fillRect(0, 6, T, 1);
    pg.fillStyle = '#7a4a22'; pg.fillRect(4, 3, 2, 2); pg.fillRect(11, 4, 2, 1);
  } else if (name === 'hoehle') {
    pg.fillStyle = '#7d73a8'; pg.fillRect(0, 0, T, 6);
    pg.fillStyle = '#a9a0d4'; pg.fillRect(0, 0, T, 1);
    pg.fillStyle = '#3b3352'; pg.fillRect(0, 5, T, 1); pg.fillRect(6, 2, 1, 2);
  } else {
    pg.fillStyle = '#7a4a22'; pg.fillRect(0, 3, T, 4);
    pg.fillStyle = '#9a6430'; pg.fillRect(0, 3, T, 1);
    pg.fillStyle = '#4fae45'; pg.fillRect(1, 0, 5, 3); pg.fillRect(9, 1, 5, 2);
    pg.fillStyle = '#86d65e'; pg.fillRect(2, 0, 2, 1); pg.fillRect(10, 1, 2, 1);
  }
  return (tileCache[name] = { mid, mid2, top, bottom, plat });
}

const LW = 512;
function circ(g, cx, cy, r, col) {
  g.fillStyle = col;
  for (let dy = -r; dy <= r; dy++) {
    const h = Math.floor(Math.sqrt(r * r - dy * dy));
    for (const o of [0, -LW, LW]) g.fillRect(Math.round(cx - h + o), Math.round(cy + dy), h * 2 + 1, 1);
  }
}
function rectW(g, x, y, w, h, col) { g.fillStyle = col; for (const o of [0, -LW, LW]) g.fillRect(Math.round(x + o), Math.round(y), w, h); }
function spike(g, x, y, w, len, dir, col) { // dir 1 = nach unten, -1 = nach oben
  for (let i = 0; i < len; i++) { const ww = Math.max(1, Math.round(w * (1 - i / len))); rectW(g, x + (w - ww) / 2, y + i * dir, ww, 1, col); }
}
function hills(g, base, amp, k1, k2, ph, col) {
  g.fillStyle = col;
  for (let x = 0; x < LW; x++) {
    const y = Math.round(base - amp * Math.sin(2 * Math.PI * x / LW * k1 + ph) - amp * 0.5 * Math.sin(2 * Math.PI * x / LW * k2 + ph * 2));
    g.fillRect(x, y, 1, VIEW_H - y);
  }
}

function buildBg(name) {
  if (bgCache[name]) return bgCache[name];
  const layers = [], R = rng(name.length * 31 + 7);
  const L = (f) => { const c = mkCanvas(LW, VIEW_H); layers.push({ c, f }); return c.getContext('2d'); };
  let sky;
  if (name === 'wald') {
    sky = ['#7ec8f0', '#d8f0ff'];
    let g = L(0.06);
    for (let i = 0; i < 6; i++) { const x = R() * LW, y = 20 + R() * 50; circ(g, x, y, 7, '#ffffff'); circ(g, x + 9, y - 3, 9, '#ffffff'); circ(g, x + 19, y, 7, '#ffffff'); rectW(g, x - 6, y + 2, 32, 6, '#ffffff'); rectW(g, x - 6, y + 7, 32, 1, '#cfe9f8'); }
    hills(L(0.18), 160, 18, 2, 5, 1, '#a6d68f');
    hills(L(0.3), 182, 14, 3, 7, 2.2, '#8cc47a');
    g = L(0.5);
    for (let i = 0; i < 9; i++) {
      const x = i * LW / 9 + R() * 30, r = 16 + R() * 10, y = 120 + R() * 30;
      rectW(g, x - 3, y, 6, VIEW_H - y, '#3e6e40');
      circ(g, x, y, r, '#4f8f52'); circ(g, x - r * 0.6, y + 8, r * 0.6, '#4f8f52'); circ(g, x + r * 0.6, y + 6, r * 0.6, '#4f8f52');
      circ(g, x - 4, y - 5, 4, '#62a564');
    }
  } else if (name === 'hoehle') {
    sky = ['#191428', '#2c2346'];
    let g = L(0.15);
    for (let i = 0; i < 14; i++) { const x = R() * LW; spike(g, x, 0, 10 + R() * 14, 30 + R() * 50, 1, '#2b2342'); spike(g, R() * LW, VIEW_H - 1, 12 + R() * 18, 30 + R() * 60, -1, '#2b2342'); }
    g = L(0.4);
    for (let i = 0; i < 8; i++) { const x = R() * LW; spike(g, x, 0, 14 + R() * 12, 40 + R() * 40, 1, '#352c52'); }
    for (let i = 0; i < 10; i++) {
      const x = R() * LW, y = 70 + R() * 120, col = i % 2 ? '#6fe3e0' : '#c58af5';
      rectW(g, x - 6, y - 6, 13, 13, 'rgba(255,255,255,0.05)');
      spike(g, x - 2, y, 5, 6, -1, col); spike(g, x - 2, y + 1, 5, 4, 1, col);
      rectW(g, x, y - 4, 1, 2, '#ffffff');
    }
  } else {
    sky = ['#4fb0ea', '#c4ebff'];
    let g = L(0.05);
    for (let i = 0; i < 5; i++) { const x = R() * LW, y = 40 + R() * 70; circ(g, x, y, 9, '#ffffff'); circ(g, x + 13, y - 4, 12, '#ffffff'); circ(g, x + 27, y, 9, '#ffffff'); rectW(g, x - 8, y + 3, 44, 7, '#ffffff'); }
    g = L(0.2);
    for (let x = 0; x < LW; x += 22) circ(g, x + R() * 8, 190 + R() * 18, 18 + R() * 8, '#8fd08a');
    rectW(g, 0, 205, LW, VIEW_H - 205, '#8fd08a');
    g = L(0.45);
    for (let i = 0; i < 6; i++) {
      const x = i * LW / 6 + R() * 40, w = 10 + R() * 6;
      rectW(g, x, 0, w, VIEW_H, '#7a5638'); rectW(g, x + 2, 0, 2, VIEW_H, '#8e6844');
      rectW(g, x + w, 60 + R() * 60, 18, 3, '#7a5638');
    }
    for (let x = 0; x < LW; x += 18) circ(g, x + R() * 10, 6 + R() * 18, 14 + R() * 8, '#5fae55');
    for (let x = 0; x < LW; x += 30) circ(g, x + R() * 10, 8 + R() * 10, 6, '#79c66a');
  }
  return (bgCache[name] = { sky, layers });
}

/* ========================== Ton ========================== */
let AC = null, soundOn = false;
function tone(f1, f2, dur, type = 'square', vol = 0.1, delay = 0) {
  if (!soundOn || !AC) return;
  const t = AC.currentTime + delay, o = AC.createOscillator(), g = AC.createGain();
  o.type = type; o.frequency.setValueAtTime(f1, t);
  if (f2 !== f1) o.frequency.exponentialRampToValueAtTime(f2, t + dur);
  g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.001, t + dur);
  o.connect(g); g.connect(AC.destination); o.start(t); o.stop(t + dur + 0.03);
}
const sfx = {
  jump()  { tone(260, 540, 0.13, 'square', 0.06); },
  acorn() { tone(988, 988, 0.05, 'square', 0.05); tone(1319, 1319, 0.09, 'square', 0.05, 0.05); },
  stomp() { tone(330, 90, 0.15, 'square', 0.09); },
  hurt()  { tone(520, 110, 0.45, 'sawtooth', 0.07); },
  heart() { [523, 659, 784, 1047].forEach((f, i) => tone(f, f, 0.09, 'triangle', 0.12, i * 0.07)); },
  check() { [392, 523, 659].forEach((f, i) => tone(f, f, 0.1, 'triangle', 0.12, i * 0.08)); },
  win()   { [523, 659, 784, 659, 784, 1047].forEach((f, i) => tone(f, f, 0.14, 'square', 0.06, i * 0.12)); },
  over()  { [392, 330, 262, 196].forEach((f, i) => tone(f, f, 0.22, 'triangle', 0.12, i * 0.2)); },
  roar()  { tone(190, 70, 0.5, 'sawtooth', 0.09); tone(120, 60, 0.55, 'square', 0.05); tone(523, 1047, 0.25, 'triangle', 0.08, 0.35); },
  click() { tone(660, 660, 0.04, 'square', 0.04); },
};

/* ========================= Level lesen ========================= */
function parseLevel(def) {
  const rows = def.map;
  const H = rows.length, W = Math.max(...rows.map(r => r.length));
  const L = { name: def.name, theme: THEMES[def.theme] ? def.theme : 'wald', tips: def.tips || [], W, H, tiles: [],
    acorns: [], hearts: [], enemies: [], checkpoints: [], lions: [], bears: [], start: null, burrow: null };
  for (let r = 0; r < H; r++) {
    const line = [];
    for (let c = 0; c < W; c++) {
      const ch = rows[r][c] || '.';
      line.push(ch === '#' || ch === '-' ? ch : '.');
      const x = c * T, y = r * T;
      if (ch === 'o') L.acorns.push({ x: x + 3, y: y + 3, w: 10, h: 10, taken: false });
      else if (ch === 'h') L.hearts.push({ x: x + 3, y: y + 3, w: 10, h: 10, taken: false });
      else if (ch === 'k') L.enemies.push({ type: 'k', x: x + 2, y: y + T - 12, w: 12, h: 12, vx: -28, vy: 0, alive: true, roll: 0, flat: 0 });
      else if (ch === 'w') L.enemies.push({ type: 'w', x: x + 2, y: y + 4, w: 12, h: 8, baseY: y + 4, t: c * 0.7, alive: true });
      else if (ch === 'p') L.checkpoints.push({ x: x + 1, y: y + T, w: 14, h: 12, active: false });
      else if (ch === 'L') L.lions.push({ x: x - 4, y: y + T - 16, w: 24, h: 16, taken: false });
      else if (ch === 'B') L.bears.push({ x: x + 8, y: y + T, i: L.bears.length, seen: false });
      else if (ch === 'F') L.burrow = { x: x + 8, y: y + T };
      else if (ch === 'S') L.start = { x: x + 3, y: y + T - 14 };
    }
    L.tiles.push(line);
  }
  if (!L.start) L.start = { x: 24, y: 0 };
  return L;
}

/* ========================= Spielzustand ========================= */
const cvs = $('.emma-canvas'), ctx = cvs.getContext('2d');
let viewW = 400, bs = 2;
let state = 'title', levelIndex = 0, L = null, tiles = null, bg = null;
let lives = 3, score = 0, scoreAtLevelStart = 0, acornsGot = 0;
let camX = 0, camY = 0, time = 0, banner = 0, particles = [];
let trail = [], toastText = '', toastT = 0, tipA = 0, tipBear = null, frameDt = 0;
let playTime = 0, runAcorns = 0;   // Spielzeit (ohne Pause) und gesammelte Eicheln des ganzen Spiels
let respawn = null, winT = 0;
const player = { x: 0, y: 0, w: 10, h: 14, vx: 0, vy: 0, face: 1, onGround: false,
  coyote: 0, buffer: 0, jumping: false, jumpT: 0, anim: 0, inv: 0, dead: false, deadT: 0, entering: false, hidden: false, boost: 0, trailT: 0 };

const keys = { left: false, right: false, jump: false };
const touch = { left: false, right: false, jump: false };
let jumpPressed = false;
const input = () => ({ left: keys.left || touch.left, right: keys.right || touch.right, jump: keys.jump || touch.jump });

function tileAt(c, r) {
  if (c < 0 || c >= L.W) return '#';
  if (r < 0 || r >= L.H) return '.';
  return L.tiles[r][c];
}
const solid = (c, r) => tileAt(c, r) === '#';

function moveX(e, dx) {
  e.x += dx;
  const top = Math.floor(e.y / T), bot = Math.floor((e.y + e.h - 0.01) / T);
  if (dx > 0) {
    const c = Math.floor((e.x + e.w - 0.01) / T);
    for (let r = top; r <= bot; r++) if (solid(c, r)) { e.x = c * T - e.w; e.vx = 0; return true; }
  } else if (dx < 0) {
    const c = Math.floor(e.x / T);
    for (let r = top; r <= bot; r++) if (solid(c, r)) { e.x = (c + 1) * T; e.vx = 0; return true; }
  }
  return false;
}
function moveY(e, dy) {
  const prevBottom = e.y + e.h;
  e.y += dy; e.onGround = false;
  const l = Math.floor(e.x / T), rr = Math.floor((e.x + e.w - 0.01) / T);
  if (dy > 0) {
    const r = Math.floor((e.y + e.h - 0.01) / T);
    for (let c = l; c <= rr; c++) {
      const t = tileAt(c, r);
      if (t === '#' || (t === '-' && prevBottom <= r * T + 0.5)) { e.y = r * T - e.h; e.vy = 0; e.onGround = true; return; }
    }
  } else if (dy < 0) {
    const r = Math.floor(e.y / T);
    for (let c = l; c <= rr; c++) if (solid(c, r)) { e.y = (r + 1) * T; e.vy = 0; return; }
  }
}

function burst(x, y, cols, n = 8, spd = 60, grav = 200, life = 0.5) {
  for (let i = 0; i < n; i++) {
    const a = Math.random() * Math.PI * 2, s = spd * (0.4 + Math.random() * 0.8);
    particles.push({ x, y, vx: Math.cos(a) * s, vy: Math.sin(a) * s - spd * 0.3, grav, life, max: life, col: cols[i % cols.length], size: Math.random() < 0.5 ? 1 : 2 });
  }
}

function placePlayer(pt) {
  Object.assign(player, { x: pt.x, y: pt.y, vx: 0, vy: 0, onGround: false, jumping: false, coyote: 0, buffer: 0, dead: false, entering: false, hidden: false, boost: 0, trailT: 0 });
}
function snapCamera() {
  camX = clamp(player.x + player.w / 2 - viewW * 0.42, 0, Math.max(0, L.W * T - viewW));
  camY = vertCam();
}
function vertCam() {
  const lh = L.H * T;
  if (lh <= VIEW_H) return lh - VIEW_H;
  return clamp(player.y + player.h / 2 - VIEW_H * 0.55, 0, lh - VIEW_H);
}

function loadLevel(i) {
  levelIndex = i;
  L = parseLevel(LEVELS[i]);
  tiles = buildTiles(L.theme); bg = buildBg(L.theme);
  particles = []; acornsGot = 0; winT = 0; trail = []; tipA = 0; tipBear = null; toastT = 0;
  respawn = { ...L.start };
  placePlayer(respawn); player.face = 1; player.inv = 0;
  scoreAtLevelStart = score;
  snapCamera();
  banner = 2.2;
}

/* =========================== Update =========================== */
function die() {
  if (player.dead || player.inv > 0 && player.y < L.H * T) return;
  lives--; player.dead = true; player.deadT = 1.1; player.vx = 0; player.boost = 0; trail = [];
  player.vy = player.y > L.H * T ? 0 : -300;
  sfx.hurt();
}
function afterDeath() {
  if (lives <= 0) { gameOver(); return; }
  placePlayer(respawn); player.inv = 1.8; snapCamera();
}

function heroFrame(p) {
  if (p.dead) return 'jump';
  if (!p.onGround && !p.entering) return p.vy < 0 ? 'jump' : 'fall';
  if (Math.abs(p.vx) > 8) return ['run1', 'run2', 'run3', 'run2'][Math.floor(p.anim) % 4];
  return 'idle';
}
function toast(s) { toastText = s; toastT = 1.8; }

function updatePlayer(dt) {
  const p = player, inp = input();
  if (p.dead) {
    p.vy = Math.min(p.vy + PHYS.gravDown * 0.7 * dt, PHYS.maxFall); p.y += p.vy * dt;
    p.deadT -= dt; if (p.deadT <= 0) afterDeath();
    return;
  }
  if (p.entering) {
    const tx = L.burrow.x - p.w / 2;
    p.x += clamp(tx - p.x, -50 * dt, 50 * dt); p.vx = 30; winT += dt;
    if (winT > 0.45) p.hidden = true;
    p.vy = Math.min(p.vy + PHYS.gravDown * dt, PHYS.maxFall); moveY(p, p.vy * dt);
    if (winT > 1.6) levelComplete();
    return;
  }
  if (p.inv > 0) p.inv -= dt;
  if (p.boost > 0) {
    p.boost -= dt; p.trailT -= dt;
    if (p.trailT <= 0 && Math.abs(p.vx) > 20) { p.trailT = 0.04; trail.push({ x: p.x, y: p.y, face: p.face, fr: heroFrame(p), life: 0.28 }); }
    if (Math.random() < dt * 40) burst(p.x + p.w / 2 - p.face * 4, p.y + p.h - 3, ['#ffcf6b', '#ff9a3c', '#ffffff'], 1, 28, 20, 0.35);
  }
  const sp = p.boost > 0 ? PHYS.boostMul : 1;

  const dir = (inp.right ? 1 : 0) - (inp.left ? 1 : 0);
  if (dir) {
    let acc = (p.onGround ? PHYS.accGround : PHYS.accAir) * sp;
    if (Math.sign(p.vx) === -dir) acc *= 1.8;
    p.vx = clamp(p.vx + dir * acc * dt, -PHYS.run * sp, PHYS.run * sp);
    p.face = dir;
  } else {
    const f = (p.onGround ? PHYS.fricGround : PHYS.fricAir) * dt;
    p.vx = Math.abs(p.vx) <= f ? 0 : p.vx - Math.sign(p.vx) * f;
  }

  if (jumpPressed) { p.buffer = PHYS.buffer; jumpPressed = false; }
  p.coyote = p.onGround ? PHYS.coyote : p.coyote - dt;
  p.buffer -= dt;
  if (p.buffer > 0 && p.coyote > 0) {
    p.vy = -PHYS.jumpV; p.jumping = true; p.jumpT = 0; p.coyote = 0; p.buffer = 0; p.onGround = false;
    sfx.jump(); burst(p.x + p.w / 2, p.y + p.h, ['#e8dcc6', '#c8b89a'], 5, 30, 50, 0.3);
  }
  if (p.jumping) {
    p.jumpT += dt;
    if (!inp.jump && p.jumpT >= PHYS.minJump && p.vy < -PHYS.cutV) p.vy = -PHYS.cutV;
    if (p.vy >= 0) p.jumping = false;
  }
  const g = (p.vy < 0 && p.jumping && inp.jump) ? PHYS.gravUp : PHYS.gravDown;
  p.vy = Math.min(p.vy + g * dt, PHYS.maxFall);

  p.prevBottom = p.y + p.h;
  moveX(p, p.vx * dt);
  const was = p.onGround;
  moveY(p, p.vy * dt);
  if (!was && p.onGround && p.prevBottom < p.y + p.h + 1) burst(p.x + p.w / 2, p.y + p.h, ['#e8dcc6'], 4, 25, 40, 0.25);
  p.anim += dt * (p.onGround ? Math.abs(p.vx) / 12 : 0);

  if (p.y > L.H * T + 24) { p.inv = 0; die(); }
}

function updateEnemies(dt) {
  for (const e of L.enemies) {
    if (!e.alive) { if (e.flat > 0) e.flat -= dt; continue; }
    if (e.x + e.w < camX - 80 || e.x > camX + viewW + 80) continue; // erst bewegen, wenn sichtbar
    if (e.type === 'k') {
      e.vy = Math.min(e.vy + PHYS.gravDown * dt, PHYS.maxFall);
      if (moveX(e, e.vx * dt)) e.vx = e.vx > 0 ? -28 : 28;
      moveY(e, e.vy * dt);
      if (e.onGround) {
        const c = e.vx > 0 ? Math.floor((e.x + e.w + 1) / T) : Math.floor((e.x - 1) / T);
        const r = Math.floor((e.y + e.h + 1) / T), t = tileAt(c, r);
        if (t !== '#' && t !== '-') e.vx = -e.vx;
      }
      e.roll += e.vx * dt / 5;
      if (e.y > L.H * T + 40) e.alive = false;
    } else {
      e.t += dt;
      e.y = e.baseY + Math.sin(e.t * Math.PI * 2 / 2.6) * 26;
    }
  }
}

function checkCollisions() {
  const p = player;
  for (const a of L.acorns) if (!a.taken && overlap(p, a)) {
    a.taken = true; acornsGot++; score += 10; sfx.acorn();
    burst(a.x + 5, a.y + 5, ['#ffe36b', '#f8d88a', '#ffffff'], 7, 50, 60, 0.45);
  }
  for (const h of L.hearts) if (!h.taken && overlap(p, h)) {
    h.taken = true; lives = Math.min(lives + 1, 9); sfx.heart();
    burst(h.x + 5, h.y + 5, ['#e8304a', '#ffb3bf', '#ffffff'], 10, 60, 40, 0.6);
  }
  for (const li of L.lions) if (!li.taken && overlap(p, li)) {
    li.taken = true; p.boost = PHYS.boostTime; score += 25; sfx.roar(); toast('Leo-Power!');
    burst(li.x + 12, li.y + 6, ['#ffcf6b', '#ff9a3c', '#7b4532', '#ffffff'], 26, 110, 60, 0.8);
  }
  for (const cp of L.checkpoints) if (!cp.active && overlap(p, { x: cp.x, y: cp.y - 16, w: cp.w, h: 16 })) {
    for (const o of L.checkpoints) o.active = false;
    cp.active = true; respawn = { x: cp.x + 2, y: cp.y - p.h }; sfx.check();
    burst(cp.x + 7, cp.y - 10, ['#e0333a', '#ffffff', '#ffe36b'], 12, 70, 80, 0.7);
  }
  for (const e of L.enemies) {
    if (!e.alive || !overlap(p, e, 2)) continue;
    if (e.type === 'k' && p.vy > 0 && p.prevBottom <= e.y + 6) {
      e.alive = false; e.flat = 0.6; score += 50; sfx.stomp();
      p.vy = input().jump ? -PHYS.jumpV : -PHYS.stomp; p.jumping = input().jump; p.jumpT = 0;
      burst(e.x + 6, e.y + 6, ['#8a4a1e', '#e9d3a2', '#ffffff'], 8, 60, 120, 0.4);
    } else if (p.inv <= 0) {
      die(); return;
    }
  }
  if (L.burrow && Math.abs(p.x + p.w / 2 - L.burrow.x) < 10 && Math.abs(p.y + p.h - L.burrow.y) < 26) {
    p.entering = true; winT = 0; p.vy = 0; sfx.win();
    burst(L.burrow.x, L.burrow.y - 40, ['#ff9a3c', '#3fa34d', '#ffe36b', '#ffffff'], 30, 110, 120, 1.2);
  }
}

function step(dt) {
  time += dt;
  updatePlayer(dt);
  if (state !== 'play') return;
  updateEnemies(dt);
  if (!player.dead && !player.entering) checkCollisions();
}

function update(dt) {
  if (state === 'play') playTime += dt;
  const n = Math.max(1, Math.ceil(dt / (1 / 120))), h = dt / n;
  for (let i = 0; i < n && state === 'play'; i++) step(h);
  for (const q of particles) { q.vy += q.grav * dt; q.x += q.vx * dt; q.y += q.vy * dt; q.life -= dt; }
  particles = particles.filter(q => q.life > 0);
  if (banner > 0) banner -= dt;
  if (toastT > 0) toastT -= dt;
  for (const q of trail) q.life -= dt;
  trail = trail.filter(q => q.life > 0);
  if (!player.dead) {
    const target = clamp(player.x + player.w / 2 - viewW * 0.42 + player.face * (player.boost > 0 ? 30 : 14), 0, Math.max(0, L.W * T - viewW));
    camX += (target - camX) * (1 - Math.exp(-5 * dt));
    camY += (vertCam() - camY) * (1 - Math.exp(-5 * dt));
  }
}

/* =========================== Zeichnen =========================== */
const DIGITS = ['111101101101111', '010110010010111', '111001111100111', '111001111001111', '101101111001001',
  '111100111001111', '111100111101111', '111001001001001', '111101111101111', '111101111001111'];
function drawNum(n, x, y, s = 2, col = '#ffffff') {
  const str = String(n);
  for (const pass of [0, 1]) {
    ctx.fillStyle = pass ? col : '#2a140a';
    const o = pass ? 0 : 1;
    for (let i = 0; i < str.length; i++) {
      const d = DIGITS[+str[i]];
      for (let k = 0; k < 15; k++) if (d[k] === '1') ctx.fillRect(x + i * 4 * s + (k % 3) * s + o, y + ((k / 3) | 0) * s + o, s, s);
    }
  }
  return str.length * 4 * s;
}

function drawBackground() {
  const [a, b] = bg.sky;
  const steps = 12, ca = hex(a), cb = hex(b);
  for (let i = 0; i < steps; i++) {
    const t = i / (steps - 1);
    ctx.fillStyle = `rgb(${ca.map((v, k) => Math.round(v + (cb[k] - v) * t)).join(',')})`;
    ctx.fillRect(0, Math.floor(i * VIEW_H / steps), viewW, Math.ceil(VIEW_H / steps) + 1);
  }
  for (const l of bg.layers) {
    const off = Math.round(((camX * l.f) % LW + LW) % LW);
    for (let x = -off; x < viewW; x += LW) ctx.drawImage(l.c, x, 0);
  }
}
function hex(h) { return [1, 3, 5].map(i => parseInt(h.slice(i, i + 2), 16)); }

function drawBurrow(bx, by) {
  const th = THEMES[L.theme];
  const dome = (r, col, dy) => {
    ctx.fillStyle = col;
    for (let y = 0; y < r; y++) {
      const hw = Math.round(r * 1.7 * Math.sqrt(1 - Math.pow((r - y) / r, 2)));
      ctx.fillRect(bx - hw, by - r + y + dy, hw * 2, 1);
    }
  };
  dome(26, '#2a140a', -1); dome(25, th.top, 0); dome(22, th.dirt, 3);
  ctx.fillStyle = th.dirtD; ctx.fillRect(bx - 22, by - 6, 3, 2); ctx.fillRect(bx + 16, by - 9, 3, 2);
  // Eingang
  ctx.fillStyle = '#1a0d06';
  for (let y = 0; y < 15; y++) { const hw = Math.round(9 * Math.sqrt(1 - Math.pow(Math.max(0, 9 - y) / 9, 2))); ctx.fillRect(bx - hw, by - 15 + y, hw * 2, 1); }
  // Fahne
  const px = bx + 18, top = by - 62;
  ctx.fillStyle = '#2a140a'; ctx.fillRect(px - 1, top - 1, 4, 52);
  ctx.fillStyle = '#e8e8e8'; ctx.fillRect(px, top, 2, 50);
  ctx.fillStyle = '#ffcf6b'; ctx.fillRect(px - 1, top - 3, 4, 3);
  const spd = player.entering ? 14 : 6;
  for (let i = 0; i < 16; i++) {
    const yo = Math.round(Math.sin(time * spd - i * 0.55) * (i / 16) * 2.5);
    ctx.fillStyle = '#2a140a'; ctx.fillRect(px + 2 + i, top + 1 + yo, 1, 11);
    ctx.fillStyle = '#ff8a2a'; ctx.fillRect(px + 2 + i, top + 2 + yo, 1, 9);
    ctx.fillStyle = '#3fa34d'; ctx.fillRect(px + 2 + i, top + 5 + yo, 1, 3);
  }
}

function draw() {
  ctx.setTransform(bs, 0, 0, bs, 0, 0);
  ctx.imageSmoothingEnabled = false;
  drawBackground();
  const cx = Math.round(camX), cy = Math.round(camY);
  ctx.save(); ctx.translate(-cx, -cy);

  const c0 = Math.max(0, Math.floor(cx / T)), c1 = Math.min(L.W - 1, Math.floor((cx + viewW) / T));
  const r0 = Math.max(0, Math.floor(cy / T)), r1 = Math.min(L.H - 1, Math.floor((cy + VIEW_H) / T));
  for (let r = r0; r <= r1; r++) for (let c = c0; c <= c1; c++) {
    const t = L.tiles[r][c];
    if (t === '#') {
      const above = r > 0 ? L.tiles[r - 1][c] : '#', below = r < L.H - 1 ? L.tiles[r + 1][c] : '#';
      const img = above !== '#' ? tiles.top : below !== '#' ? tiles.bottom : ((c * 7 + r * 13) % 3 ? tiles.mid : tiles.mid2);
      ctx.drawImage(img, c * T, r * T);
    } else if (t === '-') ctx.drawImage(tiles.plat, c * T, r * T);
  }

  if (L.burrow) drawBurrow(L.burrow.x, L.burrow.y);
  for (const b of L.bears) {
    const near = !player.dead && Math.abs(player.x + player.w / 2 - b.x) < 60 && Math.abs(player.y + player.h - b.y) < 48;
    const img = SPR.bear[near ? 1 + (Math.floor(time * 4) % 2) : 0];
    ctx.drawImage(img, Math.round(b.x - img.width / 2), Math.round(b.y - img.height + 1));
    if (!b.seen) {
      const bx = Math.round(b.x - 6), by = Math.round(b.y - img.height - 8 + Math.sin(time * 3) * 1.5);
      ctx.fillStyle = '#2a140a'; ctx.fillRect(bx - 1, by - 1, 14, 10); ctx.fillRect(bx + 2, by + 9, 3, 2);
      ctx.fillStyle = '#ffffff'; ctx.fillRect(bx, by, 12, 8); ctx.fillRect(bx + 3, by + 8, 2, 1);
      ctx.fillStyle = '#2a140a'; ctx.fillRect(bx + 2, by + 3, 2, 2); ctx.fillRect(bx + 5, by + 3, 2, 2); ctx.fillRect(bx + 8, by + 3, 2, 2);
    }
  }
  for (const cp of L.checkpoints) {
    const img = cp.active ? SPR.shroomOn : SPR.shroomOff;
    ctx.drawImage(img, cp.x - 1, cp.y - img.height + 1);
    if (cp.active && Math.floor(time * 3) % 2) { ctx.fillStyle = '#ffe36b'; ctx.fillRect(cp.x + 15, cp.y - 15, 1, 3); ctx.fillRect(cp.x + 14, cp.y - 14, 3, 1); }
  }
  for (const a of L.acorns) if (!a.taken) ctx.drawImage(SPR.acorn, a.x, Math.round(a.y + Math.sin(time * 3 + a.x * 0.1) * 1.5));
  for (const h of L.hearts) if (!h.taken) ctx.drawImage(SPR.heart, h.x + 1, Math.round(h.y + 1 + Math.sin(time * 4) * 1.5));
  for (const li of L.lions) if (!li.taken) {
    const img = SPR.lion[Math.floor(time * 2.5) % 2][1];
    const lx = Math.round(li.x + li.w / 2 - img.width / 2), ly = Math.round(li.y + li.h - img.height + 1 + Math.sin(time * 3));
    ctx.drawImage(img, lx, ly);
    if (Math.floor(time * 5) % 2) { ctx.fillStyle = '#ffe36b'; ctx.fillRect(lx + 4, ly + 2, 1, 3); ctx.fillRect(lx + 3, ly + 3, 3, 1); }
    else { ctx.fillStyle = '#ffffff'; ctx.fillRect(lx + 26, ly + 1, 1, 3); ctx.fillRect(lx + 25, ly + 2, 3, 1); }
  }

  for (const e of L.enemies) {
    if (e.type === 'k') {
      if (e.alive) {
        const f = ((Math.floor(e.roll) % 4) + 4) % 4, img = SPR.chest[f][e.vx > 0 ? 0 : 1];
        ctx.drawImage(img, Math.round(e.x + e.w / 2 - img.width / 2), Math.round(e.y + e.h) - img.height + 1);
      } else if (e.flat > 0) ctx.drawImage(SPR.chestFlat, Math.round(e.x - 1), Math.round(e.y + e.h) - 5);
    } else if (e.alive) {
      const img = SPR.wasp[Math.floor(time * 16) % 2][player.x > e.x ? 1 : 0];
      ctx.drawImage(img, Math.round(e.x - 1), Math.round(e.y - 1));
    }
  }

  const p = player;
  for (const q of trail) {
    const ti = SPR.hare[q.fr][q.face > 0 ? 0 : 1];
    ctx.globalAlpha = clamp(q.life / 0.28, 0, 1) * 0.35;
    ctx.drawImage(ti, Math.round(q.x + p.w / 2 - ti.width / 2), Math.round(q.y + p.h) - ti.height + 1);
  }
  ctx.globalAlpha = 1;
  if (!p.hidden && !(p.inv > 0 && !p.dead && Math.floor(p.inv * 12) % 2)) {
    const img = SPR.hare[heroFrame(p)][p.face > 0 ? 0 : 1];
    const dx = Math.round(p.x + p.w / 2 - img.width / 2), dy = Math.round(p.y + p.h) - img.height + 1;
    if (p.dead) {
      ctx.save(); ctx.translate(dx + img.width / 2, dy + img.height / 2); ctx.scale(1, -1);
      ctx.drawImage(img, -img.width / 2, -img.height / 2); ctx.restore();
    } else ctx.drawImage(img, dx, dy);
  }
  for (const q of particles) {
    ctx.globalAlpha = clamp(q.life / q.max * 1.5, 0, 1);
    ctx.fillStyle = q.col; ctx.fillRect(Math.round(q.x), Math.round(q.y), q.size, q.size);
  }
  ctx.globalAlpha = 1;
  ctx.restore();

  if (state !== 'title') drawHUD();
}

function wrapText(txt, maxW) {
  const words = txt.split(' '), lines = []; let cur = '';
  for (const w of words) {
    const test = cur ? cur + ' ' + w : w;
    if (ctx.measureText(test).width > maxW && cur) { lines.push(cur); cur = w; } else cur = test;
  }
  if (cur) lines.push(cur);
  return lines;
}

function drawHUD() {
  const shown = Math.min(lives, 5);
  for (let i = 0; i < shown; i++) ctx.drawImage(SPR.heart, 6 + i * 10, 6);
  if (lives > 5) drawNum(lives, 6 + 5 * 10 + 2, 7, 1);
  ctx.drawImage(SPR.acorn, 6, 19);
  drawNum(acornsGot, 19, 20, 2, '#ffe36b');
  if (player.boost > 0 && !(player.boost < 1.5 && Math.floor(time * 8) % 2)) {
    ctx.drawImage(SPR.lionHead, 4, 31);
    ctx.fillStyle = '#2a140a'; ctx.fillRect(21, 35, 38, 7);
    ctx.fillStyle = '#ffcf6b'; ctx.fillRect(22, 36, Math.round(36 * clamp(player.boost / PHYS.boostTime, 0, 1)), 5);
  }
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
  if (banner > 0) {
    ctx.globalAlpha = clamp(banner, 0, 1);
    ctx.font = 'bold 18px "Trebuchet MS", Verdana, sans-serif';
    const txt = `Level ${levelIndex + 1}: ${L.name}`;
    ctx.lineWidth = 4; ctx.strokeStyle = '#2a140a';
    ctx.strokeText(txt, viewW / 2, 70); ctx.fillStyle = '#ffcf6b'; ctx.fillText(txt, viewW / 2, 70);
    ctx.globalAlpha = 1;
  }
  if (toastT > 0) {
    ctx.globalAlpha = clamp(toastT * 2, 0, 1);
    ctx.font = 'bold 16px "Trebuchet MS", Verdana, sans-serif';
    ctx.lineWidth = 4; ctx.strokeStyle = '#2a140a';
    ctx.strokeText(toastText, viewW / 2, 100 - (1.8 - toastT) * 6); ctx.fillStyle = '#ff9a3c'; ctx.fillText(toastText, viewW / 2, 100 - (1.8 - toastT) * 6);
    ctx.globalAlpha = 1;
  }
  // Bär-Sprechblase: erscheint, wenn Emma in der Nähe eines Bären steht
  let best = null, bd = 1e9;
  if (state === 'play' && !player.dead && !player.entering)
    for (const b of L.bears) {
      const dx = Math.abs(player.x + player.w / 2 - b.x), dy = Math.abs(player.y + player.h - b.y);
      if (dx < 60 && dy < 48 && dx < bd) { bd = dx; best = b; }
    }
  if (best) { tipBear = best; best.seen = true; tipA = Math.min(1, tipA + frameDt * 6); }
  else tipA = Math.max(0, tipA - frameDt * 6);
  if (tipA > 0 && tipBear) {
    const raw = L.tips[tipBear.i] || '', txt = Array.isArray(raw) ? (stage.classList.contains('emma-is-touch') ? raw[1] : raw[0]) : raw;
    ctx.font = 'bold 9px "Trebuchet MS", Verdana, sans-serif'; ctx.textAlign = 'left'; ctx.textBaseline = 'top';
    const availW = viewW - 128, pw = Math.min(250, availW), px0 = Math.round(60 + (availW - pw) / 2), py0 = 6;
    const lines = wrapText(txt, pw - 46), ph = Math.max(38, lines.length * 11 + 10);
    ctx.globalAlpha = tipA;
    ctx.fillStyle = '#2a140a'; ctx.fillRect(px0 - 2, py0 - 2, pw + 4, ph + 4);
    ctx.fillStyle = '#fff7e6'; ctx.fillRect(px0, py0, pw, ph);
    ctx.fillStyle = '#ffe3a8'; ctx.fillRect(px0, py0, 36, ph);
    const bi = SPR.bear[1 + (Math.floor(time * 4) % 2)];
    ctx.drawImage(bi, px0 + 3, py0 + Math.round((ph - bi.height) / 2));
    ctx.fillStyle = '#3a2418';
    lines.forEach((ln, i) => ctx.fillText(ln, px0 + 42, py0 + 5 + i * 11));
    ctx.globalAlpha = 1;
  }
}

/* ======================= Bildschirme ======================= */
const overlay = $('.emma-overlay');
/* ############################ Ende des Original-Spielcodes ############################ */

let primaryAction = null;
const touchUi = () => stage.classList.contains('emma-is-touch');
function focusStage() {
  if (destroyed || !stage.isConnected) return;
  try { stage.focus({ preventScroll: true }); } catch (e) { stage.focus(); }
}
function setArt(list) {
  const box = $('.emma-ov-art'); box.innerHTML = '';
  for (const s of list) {
    const c = document.createElement('canvas'); c.width = s.width; c.height = s.height;
    c.getContext('2d').drawImage(s, 0, 0); box.appendChild(c);
  }
  box.style.display = list.length ? 'flex' : 'none';
}
function showOverlay(title, html, buttons, art = []) {
  // NEU: Steht der Fokus auf einem Knopf, der gleich ersetzt wird, bleibt er in der Bühne (Tastatur bleibt aktiv)
  if (document.activeElement !== stage && stage.contains(document.activeElement)) focusStage();
  setArt(art);
  const tEl = $('.emma-ov-title');
  if (tEl.textContent !== title) tEl.textContent = title;   // gleicher Titel: nicht neu ansagen (aria-live)
  $('.emma-ov-text').innerHTML = html;
  // NEU: Ergebnis, Bestenliste, Formulare und Konto bleiben auch im kleinen Abschnitt am Handy lesbar (CSS emma-ov-keep)
  overlay.classList.toggle('emma-ov-keep', /emma-(rank-note|board-box|form)\b/.test(html));
  const box = $('.emma-ov-btns'); box.innerHTML = '';
  buttons.forEach((b, i) => {
    const el = document.createElement('button');
    el.type = 'button';
    el.className = 'emma-btn' + (i === 0 ? ' emma-primary' : ''); el.textContent = b.label;
    // NEU: Auf Touch-Geräten öffnet jeder Knopf im Abschnitt zuerst die Vollbild-Ebene (dort ist Platz und Touch-Steuerung)
    el.addEventListener('click', () => { sfx.click(); if (touchUi() && !layerOpen) openLayer(); b.action(); });
    box.appendChild(el);
  });
  primaryAction = buttons[0].action;
  overlay.classList.remove('emma-hidden'); stage.classList.add('emma-is-ov');
  syncPauseBtn();
}
// NEU (Barrierearmut): Pause-Knopf als Umschalter – aria-pressed = Spiel ist gerade pausiert
function syncPauseBtn() { const b = $('.emma-btn-pause'); if (b) b.setAttribute('aria-pressed', state === 'pause' ? 'true' : 'false'); }
function hideOverlay() {
  overlay.classList.add('emma-hidden'); stage.classList.remove('emma-is-ov'); primaryAction = null;
  // Original: Fokus wegnehmen (blur), damit die Leertaste keinen Knopf auslöst.
  // Hier: Fokus auf die Bühne selbst – kein Knopf ist fokussiert und die Tastatur bleibt beim Spiel.
  if (layerOpen || stage.contains(document.activeElement)) focusStage();
}
function clearInput() { keys.left = keys.right = keys.jump = false; touch.left = touch.right = touch.jump = false; jumpPressed = false; }

function startRun() {
  playTime = 0; runAcorns = 0; online.runId = null; online.last = null;
  if (online.on) api('start').then(j => { if (j && j.ok) online.runId = j.runId; }).catch(() => {});
}
function titleScreen() {
  state = 'title'; screen = 'title'; score = 0; lives = 3; loadLevel(0);
  const isTouch = touchUi();
  const btns = [{ label: 'Los geht\'s', action: () => { hideOverlay(); startRun(); score = 0; lives = 3; loadLevel(0); state = 'play'; clearInput(); } }];
  if (online.on) {
    btns.push({ label: 'Bestenliste', action: () => boardScreen('current') });
    btns.push({ label: online.key ? 'Konto' : 'Anmelden', action: accountScreen });
  }
  showOverlay('Emma und die Eicheln',
    '<b>Bruno der Bär</b> erklärt: Hilf Emma, dem Hasen, alle Eicheln zu sammeln und heim in den Hasenbau zu kommen.<br>' +
    (isTouch ? 'Laufen: Knöpfe links unten. Springen: großer Knopf rechts.'
             : 'Laufen: <b>Pfeiltasten</b> oder <b>A D</b>. Springen: <b>Leertaste</b>. Pause: <b>P</b>.') +
    '<br>Kurz tippen = kleiner Sprung, festhalten = großer Sprung.' +
    '<br><b>Leo der Löwe</b> macht Emma ein paar Sekunden richtig schnell!',
    btns, [SPR.hare.idle[0], SPR.bear[1], SPR.lion[0][1]]);
}
function pauseGame() {
  if (state !== 'play') return;
  state = 'pause'; clearInput();
  showOverlay('Pause', 'Emma wartet auf dich.', [
    { label: 'Weiter', action: resumeGame },
    { label: 'Zum Start', action: titleScreen }], [SPR.bear[0]]);
}
function resumeGame() { hideOverlay(); state = 'play'; clearInput(); last = performance.now(); syncPauseBtn(); }
function fmtTime(s) { return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
function levelComplete() {
  state = 'done'; clearInput();
  const total = L.acorns.length, isLast = levelIndex === LEVELS.length - 1;
  score += 100; runAcorns += acornsGot;
  const info = `Du hast <b>${acornsGot} von ${total}</b> Eicheln gesammelt.<br>Punkte: <b>${score}</b>`;
  if (isLast) {
    online.last = { score, time: Math.round(playTime), acorns: runAcorns, levels: LEVELS.length, sent: false };
    const btns = [{ label: 'Nochmal spielen', action: () => { hideOverlay(); startRun(); score = 0; lives = 3; loadLevel(0); state = 'play'; } }];
    if (online.on) btns.push({ label: 'Bestenliste', action: () => boardScreen('current') });
    btns.push({ label: 'Zum Start', action: titleScreen });
    screen = 'done';
    const allAcorns = LEVELS.reduce((n, l) => n + l.map.join('').split('o').length - 1, 0);
    showOverlay('Emma ist zu Hause!',
      `Bruno: Alle Level geschafft!<br>Eicheln: <b>${runAcorns} von ${allAcorns}</b> &nbsp; Punkte: <b>${score}</b> &nbsp; Zeit: <b>${fmtTime(online.last.time)}</b><div class="emma-rank-note"></div>`,
      btns, [SPR.hare.idle[0], SPR.bear[1]]);
    if (online.on) finishOnline();
  } else {
    showOverlay('Level geschafft!', 'Bruno: Super gemacht!<br>' + info, [
      { label: 'Weiter', action: () => { hideOverlay(); loadLevel(levelIndex + 1); state = 'play'; } }], [SPR.bear[1]]);
  }
}
function gameOver() {
  state = 'over'; clearInput(); sfx.over();
  showOverlay('Game Over', 'Bruno: Nicht aufgeben! Probier es gleich nochmal.', [
    { label: 'Nochmal', action: () => { hideOverlay(); lives = 3; score = scoreAtLevelStart; loadLevel(levelIndex); state = 'play'; } },
    { label: 'Zum Start', action: titleScreen }], [SPR.bear[0]]);
}

/* ===== Online: Anmeldung, Bestenliste, Ergebnis eintragen (braucht api.php auf einem PHP-Server) ===== */
const API = normApi(root.getAttribute('data-api-url'));   // leer = ohne Anmeldung und Bestenliste
const online = { on: false, cfg: {}, nick: '', key: '', confirmed: false, runId: null, last: null };
let screen = 'title';
try { const s = JSON.parse(localStorage.getItem('emma.acc') || 'null'); if (s && s.key) { online.nick = s.nick; online.key = s.key; } } catch (e) {}
function saveAcc() {
  try { if (online.key) localStorage.setItem('emma.acc', JSON.stringify({ nick: online.nick, key: online.key })); else localStorage.removeItem('emma.acc'); } catch (e) {}
}
const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
async function api(action, data) {
  if (!API || destroyed) throw new Error('kein Server');
  const ctl = new AbortController(), to = setTimeout(() => ctl.abort(), 8000);
  try {
    // Anderer Server als der Shop: CORS-Anfrage ohne Cookies (der Anmelde-Schlüssel steht im Körper der Anfrage)
    const r = await fetch(API + (API.indexOf('?') < 0 ? '?' : '&') + 'a=' + action, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data || {}), signal: ctl.signal });
    return await r.json();
  } finally { clearTimeout(to); }
}
async function refreshMe() {
  if (!online.on || !online.key) return false;
  try {
    const m = await api('me', { key: online.key });
    if (m.ok) { const ch = m.confirmed !== online.confirmed || m.nick !== online.nick; online.confirmed = m.confirmed; online.nick = m.nick; return ch; }
    if (m.err === 'unknown') { online.key = ''; online.nick = ''; saveAcc(); return true; }
  } catch (e) {}
  return false;
}
function removeLoginParam() {   // nur ?login=… aus der Adresse nehmen, andere Parameter und #Anker bleiben
  try {
    const u = new URL(location.href);
    if (!u.searchParams.has('login')) return;
    u.searchParams.delete('login');
    history.replaceState(history.state, '', u.pathname + u.search + u.hash);
  } catch (e) {}
}
// NEU: Der Server wird erst gefragt, wenn das Spiel zum ersten Mal sichtbar ist (nicht schon beim Laden jeder Shop-Seite)
let onlineStarted = false;
function startOnline() { if (onlineStarted || destroyed) return; onlineStarted = true; onlineInit(); }
async function onlineInit() {
  if (!API) return;   // keine Server-Adresse eingestellt: Spiel läuft wie index.html allein
  try { const c = await api('config'); if (c && c.ok) { online.on = true; online.cfg = c; } } catch (e) {}
  if (!online.on || destroyed) return;
  if (loginToken) {
    try {
      const k = API + '|' + loginToken;
      if (!loginOnce.has(k)) loginOnce.set(k, api('login', { token: loginToken }));
      const j = await loginOnce.get(k);
      if (j && j.ok) { online.nick = j.nick; online.key = j.key; online.confirmed = j.confirmed; saveAcc(); }
    } catch (e) {}
    removeLoginParam();
  }
  await refreshMe();
  if (destroyed) return;
  if (screen === 'title' && state === 'title') titleScreen();
}

function formScreen(title, intro, fields, buttons) {
  screen = 'form';
  showOverlay(title, '<div class="emma-form"><div class="emma-intro">' + intro + '</div>' + fields + '<div class="emma-form-msg emma-msg"></div></div>', buttons, []);
}
function msgSet(text, ok) { const m = $('.emma-form-msg'); if (m) { m.textContent = text; m.className = 'emma-form-msg emma-msg' + (ok ? ' emma-ok' : ''); } }
const MAIL_RE = /^\S+@\S+\.\S+$/;

function accountScreen() {
  if (online.key) { kontoScreen(); return; }
  const c = online.cfg, link = (u, txt) => typeof u === 'string' && /^https?:///i.test(u) ? `<a href="${esc(u)}" target="_blank" rel="noopener">${txt}</a>` : txt;   // nur http(s)-Links vom Server
  formScreen('Anmelden', 'Mit einem Spitznamen kommst du in die Bestenliste und kannst am Monatsende etwas gewinnen.',
    `<label>Spitzname (bitte kein echter Name)<input class="emma-input emma-f-nick" type="text" maxlength="14" autocomplete="off" autocapitalize="off" spellcheck="false"></label>
     <label>E-Mail der Eltern<input class="emma-input emma-f-mail" type="email" maxlength="120" autocomplete="email" inputmode="email"></label>
     <label class="emma-chk"><input class="emma-check emma-f-ok" type="checkbox"><span>Ich bin Elternteil oder meine Eltern erlauben die Teilnahme. Ich habe die ${link(c.privacy_url, 'Datenschutzerklärung')} und die ${link(c.rules_url, 'Teilnahmebedingungen')} gelesen.</span></label>
     <input class="emma-hp emma-f-hp" tabindex="-1" autocomplete="off" aria-hidden="true">`,
    [{ label: 'Anmelden', action: doRegister }, { label: 'Ich habe schon ein Konto', action: loginScreen }, { label: 'Zurück', action: titleScreen }]);
}
async function doRegister() {
  const nick = $('.emma-f-nick').value.trim(), email = $('.emma-f-mail').value.trim(), ok = $('.emma-f-ok').checked, hp = $('.emma-f-hp').value;
  if (nick.length < 3) return msgSet('Der Spitzname braucht mindestens 3 Zeichen.');
  if (!MAIL_RE.test(email)) return msgSet('Bitte gib eine gültige E-Mail-Adresse ein.');
  if (!ok) return msgSet('Bitte bestätige die Erlaubnis der Eltern und die Datenschutzerklärung.');
  msgSet('Einen Moment …', true);
  try {
    const j = await api('register', { nick, email, consent: ok, hp });
    if (!j.ok) return msgSet(j.msg || 'Das hat nicht geklappt.');
    online.nick = j.nick; online.key = j.key; online.confirmed = false; saveAcc();
    screen = 'registered';
    showOverlay('Fast geschafft!',
      `Wir haben eine E-Mail an <b>${esc(email)}</b> geschickt. Bitte auf den Link darin klicken. Erst dann erscheint <b>${esc(j.nick)}</b> in der Bestenliste.<div class="emma-rank-note"></div>`,
      [{ label: 'Weiter', action: titleScreen }], [SPR.hare.idle[0], SPR.bear[1]]);
    if (online.last && !online.last.sent) submitPending();
  } catch (e) { msgSet('Keine Verbindung zum Server.'); }
}
function loginScreen() {
  formScreen('Schon angemeldet?', 'Gib die E-Mail der Eltern ein. Wir schicken einen Link, mit dem du dich auf diesem Gerät anmeldest.',
    '<label>E-Mail der Eltern<input class="emma-input emma-f-mail" type="email" maxlength="120" autocomplete="email" inputmode="email"></label>',
    [{ label: 'Link schicken', action: doLoginRequest }, { label: 'Zurück', action: accountScreen }]);
}
async function doLoginRequest() {
  const email = ($('.emma-f-mail').value || '').trim();
  if (!MAIL_RE.test(email)) return msgSet('Bitte gib eine gültige E-Mail-Adresse ein.');
  msgSet('Einen Moment …', true);
  try {
    const j = await api('login_request', { email });
    msgSet(j.ok ? 'Wenn es ein Konto gibt, ist eine E-Mail unterwegs. Der Link gilt 1 Stunde.' : (j.msg || 'Das hat nicht geklappt.'), !!j.ok);
  } catch (e) { msgSet('Keine Verbindung zum Server.'); }
}
function kontoScreen() {
  screen = 'konto';
  let armed = false;
  showOverlay('Konto',
    `Angemeldet als <b>${esc(online.nick)}</b>.<br>` +
    (online.confirmed ? 'Die E-Mail ist bestätigt.' : 'Bitte klicke noch auf den Link in der Bestätigungs-E-Mail, sonst erscheinst du nicht in der Bestenliste.') +
    '<div class="emma-form"><div class="emma-form-msg emma-msg"></div></div>',
    [{ label: 'Zurück', action: titleScreen },
     { label: 'Abmelden', action: () => { online.key = ''; online.nick = ''; saveAcc(); titleScreen(); } },
     { label: 'Konto löschen', action: async () => {
         const b = $('.emma-ov-btns').children[2];
         if (!armed) { armed = true; b.textContent = 'Wirklich löschen?'; msgSet('Spitzname, E-Mail-Adresse und alle Punkte werden gelöscht.'); return; }
         try {
           const j = await api('delete', { key: online.key });
           if (j.ok || j.err === 'unknown') { online.key = ''; online.nick = ''; saveAcc(); titleScreen(); } else msgSet(j.msg || 'Das hat nicht geklappt.');
         } catch (e) { msgSet('Keine Verbindung zum Server.'); }
       } }], []);
  refreshMe().then(changed => { if (changed && screen === 'konto') accountScreen(); });
}

async function boardScreen(which) {
  screen = 'board';
  const prev = which === 'prev';
  showOverlay('Bestenliste', '<div class="emma-board-box">Lade …</div>', [
    { label: 'Zurück', action: titleScreen },
    { label: prev ? 'Dieser Monat' : 'Letzter Monat', action: () => boardScreen(prev ? 'current' : 'prev') }], []);
  const fail = t => { const b = $('.emma-board-box'); if (b && screen === 'board') b.textContent = t; };
  try {
    const j = await api('board', { month: which, key: online.key });
    const box = $('.emma-board-box'); if (!box || screen !== 'board') return;
    if (!j.ok) return fail(j.msg || 'Das hat nicht geklappt.');
    box.innerHTML = '';
    const add = (cls, txt) => { const d = document.createElement('div'); if (cls) d.className = cls; d.textContent = txt; box.appendChild(d); return d; };
    add('emma-bhead', j.label);
    if (!j.rows.length) add('', 'Noch niemand. Sei die Erste oder der Erste!');
    else {
      const tb = document.createElement('table'); tb.className = 'emma-board';
      for (const r of j.rows) {
        const tr = document.createElement('tr');
        if (r.me) tr.classList.add('emma-me');
        if (r.rank <= 3) tr.classList.add('emma-top' + r.rank);
        [r.rank + '.', r.nick, r.score, fmtTime(r.time)].forEach((c, i) => {
          const td = document.createElement('td'); td.textContent = c; if (i >= 2) td.className = 'emma-num'; tr.appendChild(td);
        });
        tb.appendChild(tr);
      }
      box.appendChild(tb);
    }
    if (j.me && !j.rows.some(r => r.me)) add('', `Du: Platz ${j.me.rank} mit ${j.me.score} Punkten`);
    if (j.prize && !prev) add('emma-prize', j.prize);
  } catch (e) { fail('Keine Verbindung zum Server.'); }
}

// Nach dem letzten Level: Ergebnis eintragen (oder zur Anmeldung einladen)
function finishOnline() {
  const note = $('.emma-rank-note'); if (!note) return;
  if (online.key) { submitPending(); return; }
  note.textContent = 'Du willst in die Bestenliste? Melde dich an und trag deine Punkte ein! ';
  const b = document.createElement('button'); b.type = 'button'; b.className = 'emma-btn emma-small'; b.textContent = 'Anmelden';
  b.addEventListener('click', () => { sfx.click(); if (touchUi() && !layerOpen) openLayer(); accountScreen(); });
  note.appendChild(document.createElement('br')); note.appendChild(b);
}
async function submitPending() {
  const r = online.last, setNote = h => { const n = $('.emma-rank-note'); if (n) n.innerHTML = h; };
  if (!r || r.sent) return;
  if (!online.runId) return setNote('Dieses Mal konnte das Ergebnis nicht eingetragen werden.');
  setNote('Punkte werden eingetragen …');
  try {
    const j = await api('submit', { key: online.key, runId: online.runId, score: r.score, time: r.time, acorns: r.acorns, levels: r.levels });
    if (j.ok) {
      r.sent = true;
      setNote(`Platz <b>${esc(j.rank)}</b> in der Bestenliste (${esc(j.label)}).` + (j.confirmed ? '' : '<br>Bitte bestätige noch deine E-Mail, sonst bleibst du unsichtbar.'));
    } else if (j.err === 'unknown') { online.key = ''; online.nick = ''; saveAcc(); setNote('Das Konto wurde nicht gefunden. Bitte melde dich neu an.'); }
    else setNote(esc(j.msg || 'Das hat leider nicht geklappt.'));
  } catch (e) { setNote('Keine Verbindung zum Server.'); }
}

/* ========================= Steuerung ========================= */
// NEU: Die Tastatur gehört nur dann dem Spiel, wenn es aktiv ist: Bühne (oder etwas darin) hat den Fokus
// oder die Vollbild-Ebene ist offen. Sonst bleiben Pfeiltasten und Leertaste beim Shop (Seite scrollt normal).
const gameActive = () => layerOpen || stage.contains(document.activeElement);
const KEYMAP = { ArrowLeft: 'left', KeyA: 'left', ArrowRight: 'right', KeyD: 'right', Space: 'jump', ArrowUp: 'jump', KeyW: 'jump' };
// NEU: Tab bleibt in der offenen Vollbild-Ebene (am Ende wieder vorn, Umschalt+Tab umgekehrt)
function trapTab(e) {
  const list = [stage].concat(Array.prototype.filter.call(
    stage.querySelectorAll('button, a[href], input:not([tabindex="-1"]), textarea, select'),
    el => !el.disabled && el.getClientRects().length > 0));
  const i = list.indexOf(document.activeElement);
  const n = i < 0 ? (e.shiftKey ? list.length - 1 : 0) : i + (e.shiftKey ? -1 : 1);
  if (i < 0 || n < 0 || n >= list.length) {
    e.preventDefault();
    const z = list[(n + list.length) % list.length];
    try { z.focus({ preventScroll: true }); } catch (err) { z.focus(); }
  }
}
on(window, 'keydown', e => {
  if (!gameActive()) return;
  if (e.key === 'Tab') { if (layerOpen) trapTab(e); return; }
  // NEU: Enter/Leertaste auf einem Knopf oder Link in der Bühne löst genau diesen aus (Browser-Standard),
  // nicht primaryAction – sonst wären Vollbild, Schließen, Ton, Pause und die Links nicht per Tastatur bedienbar.
  const t = e.target;
  if (t && t !== stage && stage.contains(t) && /^(BUTTON|A)$/.test(t.tagName)
      && (e.key === 'Enter' || e.key === ' ' || e.code === 'Space' || e.code === 'NumpadEnter')) return;
  if (e.target && /^(INPUT|TEXTAREA)$/.test(e.target.tagName)) {   // beim Tippen in Formularen nichts abfangen
    if (e.code === 'Enter' && primaryAction) { e.preventDefault(); primaryAction(); }
    return;
  }
  const k = KEYMAP[e.code];
  if (k || e.code === 'Space' || e.code === 'ArrowDown') e.preventDefault();   // NEU ArrowDown: im Original war die Seite fest, im Shop würde sie sonst mitten im Spiel scrollen
  if (e.code === 'Escape' && layerOpen) { e.preventDefault(); closeLayer(); return; }   // NEU: Esc schließt die Vollbild-Ebene
  if (e.code === 'KeyP' || e.code === 'Escape') { if (state === 'play') pauseGame(); else if (state === 'pause') resumeGame(); return; }
  if (e.code === 'Enter' && primaryAction) { e.preventDefault(); sfx.click(); primaryAction(); return; }
  if (!k || state !== 'play') return;
  if (k === 'jump' && !keys.jump && !e.repeat) jumpPressed = true;
  keys[k] = true;
});
on(window, 'keyup', e => { const k = KEYMAP[e.code]; if (k) keys[k] = false; });

function setupTouch() {
  const dpad = $('.emma-dpad'), tl = $('.emma-tl'), tr = $('.emma-tr'), tj = $('.emma-tj'), ptrs = new Map();
  const side = e => { const r = dpad.getBoundingClientRect(); return e.clientX < r.left + r.width / 2 ? 'l' : 'r'; };
  const sync = () => {
    const v = [...ptrs.values()];
    touch.left = v.includes('l'); touch.right = v.includes('r');
    tl.classList.toggle('emma-on', touch.left); tr.classList.toggle('emma-on', touch.right);
  };
  on(dpad, 'pointerdown', e => { e.preventDefault(); dpad.setPointerCapture(e.pointerId); ptrs.set(e.pointerId, side(e)); sync(); });
  on(dpad, 'pointermove', e => { if (ptrs.has(e.pointerId)) { ptrs.set(e.pointerId, side(e)); sync(); } });
  const up = e => { ptrs.delete(e.pointerId); sync(); };
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(n => on(dpad, n, up));
  on(tj, 'pointerdown', e => {
    e.preventDefault(); tj.setPointerCapture(e.pointerId);
    if (!touch.jump && state === 'play') jumpPressed = true;
    touch.jump = true; tj.classList.add('emma-on');
  });
  const jup = () => { touch.jump = false; tj.classList.remove('emma-on'); };
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(n => on(tj, n, jup));
}

function markTouch() { if (!stage.classList.contains('emma-is-touch')) stage.classList.add('emma-is-touch'); }
// Touch-Gerät = Hauptzeiger ist ein Finger ohne Hover (Handy, Tablet). Original: 'ontouchstart' in window || pointer: coarse –
// das träfe im Shop auch Laptops mit Touchscreen (jeder Mausklick öffnete dann das Vollbild). Wer wirklich auf die
// Bühne tippt, wird weiterhin sofort als Touch erkannt (touchstart unten).
if (window.matchMedia ? matchMedia('(hover: none) and (pointer: coarse)').matches : ('ontouchstart' in window)) markTouch();
on(stage, 'touchstart', markTouch, { passive: true });
// Sperren nur in der Bühne: Wischen und Zwei-Finger-Zoom nur in der Vollbild-Ebene (siehe openLayer),
// im Abschnitt bleibt die Seite über dem Spiel scrollbar. Doppelklick und Kontextmenü immer in der Bühne.
const blockTouchMove = e => { if (!(e.target.closest && e.target.closest('.emma-panel'))) e.preventDefault(); };
const blockGesture = e => e.preventDefault();
on(stage, 'dblclick', e => e.preventDefault());
on(stage, 'contextmenu', e => e.preventDefault());
// Klick/Tipp in die Bühne macht das Spiel aktiv (Fokus), damit die Tastatur ankommt
on(stage, 'pointerdown', () => { if (!stage.contains(document.activeElement)) focusStage(); }, true);

const SPEAKER_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h4l5-4v14l-5-4H3z" fill="#2a140a"/><path d="M15 8c1.5 1 1.5 7 0 8M18 5c3 2.5 3 11.5 0 14" stroke="#2a140a" stroke-width="2" fill="none"/></svg>';
const SPEAKER_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h4l5-4v14l-5-4H3z" fill="#2a140a"/><path d="M15 9l6 6M21 9l-6 6" stroke="#2a140a" stroke-width="2.4"/></svg>';
function soundIcon() { $('.emma-btn-sound').innerHTML = soundOn ? SPEAKER_ON : SPEAKER_OFF; $('.emma-btn-sound').setAttribute('aria-pressed', soundOn); }
on($('.emma-btn-sound'), 'click', () => {
  soundOn = !soundOn;
  if (soundOn) {
    const A = window.AudioContext || window.webkitAudioContext;
    if (!AC && A) AC = new A();
    if (AC && AC.state === 'suspended') AC.resume();
    sfx.click();
  }
  soundIcon(); focusStage();   // Original: blur(); hier bleibt der Fokus in der Bühne
});
on($('.emma-btn-pause'), 'click', () => {
  if (state === 'play') pauseGame();
  else if (state === 'pause') { resumeGame(); if (touchUi() && !layerOpen) openLayer(); }
  focusStage();
});
on(window, 'blur', () => { if (state === 'play') pauseGame(); });
on(document, 'visibilitychange', () => { if (document.hidden && state === 'play') pauseGame(); });
// NEU: Verlässt der Fokus im Abschnitt die Bühne (Klick daneben, Tab), pausiert das Spiel – die Tastatur ist dann weg
on(stage, 'focusout', e => {
  if (layerOpen || destroyed) return;
  if (e.relatedTarget && stage.contains(e.relatedTarget)) return;
  if (state === 'play') pauseGame();
  clearInput();
});

/* ===================== Vollbild-Ebene (NEU) =====================
   Die Bühne wandert ans Ende von <body> (position: fixed, ganz oben) – so stören weder transform/overflow
   der Theme-Container noch Kopfzeile oder Cookie-Leiste. Zusätzlich echtes Vollbild, wenn der Browser es kann.
   Esc, Schließen-Knopf oder das Beenden des echten Vollbilds schließen die Ebene und pausieren das Spiel. */
const fsElement = () => document.fullscreenElement || document.webkitFullscreenElement || null;
function lockLandscape() { try { const o = window.screen && window.screen.orientation; if (o && o.lock) o.lock('landscape').catch(() => {}); } catch (e) {} }
function unlockOrientation() { try { const o = window.screen && window.screen.orientation; if (o && o.unlock) o.unlock(); } catch (e) {} }
function setScrollLock(onOff) {
  const de = document.documentElement, b = document.body;
  if (onOff) { de.classList.add('emma-scroll-lock'); b.classList.add('emma-scroll-lock'); }
  else if (!document.querySelector('.emma-game.emma-is-layer')) { de.classList.remove('emma-scroll-lock'); b.classList.remove('emma-scroll-lock'); }
}
function openLayer() {
  if (layerOpen || destroyed) return;
  layerOpen = true;
  clearInput();
  slot.classList.add('emma-slot-away');
  document.body.appendChild(stage);
  stage.classList.add('emma-is-layer');
  setScrollLock(true);
  stage.addEventListener('touchmove', blockTouchMove, { passive: false });
  stage.addEventListener('gesturestart', blockGesture);
  const gesture = !navigator.userActivation || navigator.userActivation.isActive;   // echtes Vollbild geht nur direkt nach einem Klick/Tipp
  if (gesture && (document.fullscreenEnabled || document.webkitFullscreenEnabled)) {
    try {
      const p = stage.requestFullscreen ? stage.requestFullscreen({ navigationUI: 'hide' }) : (stage.webkitRequestFullscreen && stage.webkitRequestFullscreen());
      if (p && typeof p.catch === 'function') p.catch(() => {});   // abgelehnt (z. B. im Theme-Editor): Ebene bleibt trotzdem offen
    } catch (e) {}
  }
  focusStage(); resize(); updateRunning();
}
function closeLayer(silent) {
  if (!layerOpen) return;
  layerOpen = false;
  if (!silent && state === 'play') pauseGame();
  clearInput();
  stage.removeEventListener('touchmove', blockTouchMove, { passive: false });
  stage.removeEventListener('gesturestart', blockGesture);
  if (fsElement() === stage) {
    nativeFs = false;
    try {
      const p = document.exitFullscreen ? document.exitFullscreen() : (document.webkitExitFullscreen && document.webkitExitFullscreen());
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch (e) {}
  }
  nativeFs = false;
  unlockOrientation();
  stage.classList.remove('emma-is-layer');
  slot.appendChild(stage);
  slot.classList.remove('emma-slot-away');
  setScrollLock(false);
  if (!silent) { resize(); focusStage(); updateRunning(); }
}
function onFullscreenChange() {
  if (fsElement() === stage) { nativeFs = true; if (touchUi()) lockLandscape(); return; }
  if (nativeFs) { nativeFs = false; if (layerOpen) closeLayer(); }   // Esc/Zurück hat das echte Vollbild beendet
}
on(document, 'fullscreenchange', onFullscreenChange);
on(document, 'webkitfullscreenchange', onFullscreenChange);
on($('.emma-btn-fs'), 'click', () => openLayer());
on($('.emma-btn-close'), 'click', () => closeLayer());

/* ===================== Größe: Bühne statt Fenster ===================== */
function resize() {
  const iw = stage.clientWidth, ih = stage.clientHeight, dpr = window.devicePixelRatio || 1;
  if (!iw || !ih) return;
  viewW = clamp(Math.round(VIEW_H * iw / ih), 300, 480);
  const scale = Math.min(iw / viewW, ih / VIEW_H);
  bs = Math.max(1, Math.round(scale * dpr));
  if (cvs.width !== viewW * bs || cvs.height !== VIEW_H * bs) { cvs.width = viewW * bs; cvs.height = VIEW_H * bs; }
  const cw = viewW * scale, ch = VIEW_H * scale;
  Object.assign(cvs.style, { width: cw + 'px', height: ch + 'px', left: (iw - cw) / 2 + 'px', top: (ih - ch) / 2 + 'px' });
  ctx.imageSmoothingEnabled = false;
  // Stil-Maße relativ zur Bühne (im Original vh/vw und @media (max-height: 470px) am Fenster)
  stage.style.setProperty('--emma-vh', (ih / 100) + 'px');
  stage.style.setProperty('--emma-vw', (iw / 100) + 'px');
  stage.classList.toggle('emma-compact', ih <= 470);
  stage.classList.toggle('emma-tiny', ih <= 300);
  if (!running && L) draw();   // angehaltene Schleife: neu gezeichnetes Bild trotzdem zeigen
}
let ro = null, io = null;
if (window.ResizeObserver) { ro = new ResizeObserver(() => { if (!destroyed) resize(); }); ro.observe(stage); }
else on(window, 'resize', resize);
on(window, 'orientationchange', () => setTimeout(() => { if (!destroyed) resize(); }, 200));
// Nicht sichtbar (weggescrollt) und keine Vollbild-Ebene: Spiel pausieren, Schleife anhalten
if (window.IntersectionObserver) {
  io = new IntersectionObserver(entries => {
    for (const en of entries) visible = en.isIntersecting;
    if (visible) startOnline();   // NEU: Server erst fragen, wenn das Spiel zum ersten Mal sichtbar ist
    updateRunning();
  });
  io.observe(slot);
}

/* ========================= Hauptschleife ========================= */
let last = performance.now(), rafId = 0, running = false;
function loop(now) {
  rafId = 0;
  if (!running || destroyed) return;
  const dt = clamp((now - last) / 1000, 0, 1 / 20); last = now; frameDt = dt;
  const portraitTouch = touchUi() && layerOpen && window.innerHeight > window.innerWidth;
  if (state === 'play' && !portraitTouch) update(dt);
  else if (state === 'title') { time += dt; camX = (camX + 18 * dt) % Math.max(1, L.W * T - viewW); }
  else time += dt * (state === 'done' ? 1 : 0);
  if (state === 'done') { for (const q of particles) { q.vy += q.grav * dt; q.x += q.vx * dt; q.y += q.vy * dt; q.life -= dt; } particles = particles.filter(q => q.life > 0); }
  draw();
  rafId = requestAnimationFrame(loop);
}
function startLoop() { if (running || destroyed) return; running = true; last = performance.now(); rafId = requestAnimationFrame(loop); }
function stopLoop() { running = false; if (rafId) cancelAnimationFrame(rafId); rafId = 0; }
function updateRunning() {
  if (destroyed) { stopLoop(); return; }
  if (layerOpen || visible) startLoop();
  else { if (state === 'play') pauseGame(); stopLoop(); }
}

function destroy() {
  if (destroyed) return;
  closeLayer(true);
  destroyed = true;
  stopLoop();
  if (ro) ro.disconnect();
  if (io) io.disconnect();
  while (offs.length) { try { offs.pop()(); } catch (e) {} }
  stage.removeEventListener('touchmove', blockTouchMove, { passive: false });
  stage.removeEventListener('gesturestart', blockGesture);
  clearInput();
  if (AC) { try { const p = AC.close(); if (p && p.catch) p.catch(() => {}); } catch (e) {} AC = null; }
  soundOn = false;
}

buildSprites(); setupTouch(); soundIcon(); resize();
titleScreen();
$('.emma-ov-title').setAttribute('aria-live', 'polite');   // NEU: ab jetzt werden neue Titel (Pause, Game Over …) angesagt, der erste nicht
updateRunning();
// Online-Teil: ohne IntersectionObserver oder mit Anmelde-Link sofort, sonst beim ersten Sichtbarwerden (siehe oben)
if (!io || loginToken) startOnline();

const inst = { root, stage, destroy, openLayer: () => openLayer(), closeLayer: () => closeLayer() };
if (testMode) {
  // Nur für die lokale Testseite (data-emma-test): Zustand lesen und das Spielende abkürzen
  inst.test = {
    zustand: () => ({ state, screen, level: levelIndex, score, lives, x: Math.round(player.x), layerOpen, nativeFs, running, visible, viewW, bs,
      touch: touchUi(), aktiv: gameActive(), online: { on: online.on, nick: online.nick, confirmed: online.confirmed, runId: online.runId, last: online.last } }),
    durchspielen: sek => {   // als ob Level 1 und 2 ohne Eicheln geschafft wären, dann Ziel im letzten Level erreichen
      if (state !== 'play' && state !== 'pause') return false;
      if (state === 'pause') hideOverlay();
      score = 100 * (LEVELS.length - 1); runAcorns = 0;
      loadLevel(LEVELS.length - 1); state = 'play';
      playTime = Math.max(playTime, sek || 0);
      levelComplete();
      return true;
    }
  };
}
return inst;
}

/* ===================== Verwaltung: Starten und Abbauen ===================== */
function scan(scope) {
  for (const [r, inst] of instances) if (!r.isConnected) { inst.destroy(); instances.delete(r); }
  const sc = scope && scope.querySelectorAll ? scope : document;
  const list = Array.prototype.slice.call(sc.querySelectorAll('[data-emma-root]'));
  if (sc.matches && sc.matches('[data-emma-root]')) list.unshift(sc);
  for (const r of list) {
    if (instances.has(r)) continue;
    try { instances.set(r, createGame(r)); }
    catch (err) { if (window.console) console.error('[Emma und die Eicheln] Start fehlgeschlagen:', err); }
  }
}
function unmount(scope) {
  for (const [r, inst] of instances) {
    if (!scope || scope === r || (scope.contains && scope.contains(r))) { inst.destroy(); instances.delete(r); }
  }
}
window[NS] = { version: '1.2.0', scan, unmount, instances };
// Custom Element <emma-und-die-eicheln>: startet, sobald es im Dokument steht, und räumt ab, wenn es entfernt wird.
// Das deckt auch Fälle ohne Theme-Editor-Ereignisse ab (z. B. Themes mit AJAX-Seitenwechsel). Wird das Element nur
// verschoben (Abschnitte umsortieren), bleibt das laufende Spiel erhalten (Prüfung erst nach der DOM-Änderung).
if (window.customElements && !window.customElements.get('emma-und-die-eicheln')) {
  window.customElements.define('emma-und-die-eicheln', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading' || !this.hasAttribute('data-emma-root') || instances.has(this)) return;   // während des Ladens übernimmt scan()
      scan(this);
    }
    disconnectedCallback() {
      const el = this;
      Promise.resolve().then(() => { if (!el.isConnected && instances.has(el)) unmount(el); });
    }
  });
}
// Theme-Editor: Abschnitt neu geladen (Einstellung geändert, eingefügt) bzw. entfernt
document.addEventListener('shopify:section:load', e => scan(e.target));
document.addEventListener('shopify:section:unload', e => unmount(e.target));
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
else scan(document);
})();
